import _ from 'lodash';

function MemberCtrl($rootScope, $scope, $http, $window, $timeout, $state, $stateParams, $compile, $q, $sce, toastr, AppSettings, UserService, PlanService, PlayerService, AuthService, AppContextService, $ngConfirm, TeamService, BioService, AnalysisService, AdminService, DeviceService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  // vm.oppo_team = JSON.parse(sessionStorage.getItem('oppo_team'));

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    // vm.isDebugger = true;
    // vm.isDebugger = false;
  }

  function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  const currentYear = (new Date()).getFullYear();

  // bluetooth start
  if (vm.appContext.role2 === 'sa21c') {
    document.addEventListener("deviceready", function() {
      ble.isEnabled(
        function(){
          // Bluetooth is enabled
        },
        function(){
          // Bluetooth not yet enabled so we try to enable it
          ble.enable(
            function(){
              // bluetooth now enabled
            },
            function(err){
              alert('Cannot enable bluetooth');
            }
          );
        }
      );
  
      var devices = [];
      vm.devices = [];
  
      vm.deviceScan = function(){
  
        ble.startScan(
          [],
          function(device){
            if(!device.name){
              device.name = 'No name';
            }
            devices.push(device);
          },
          function(err){
            alert('디바이스 스캔에 실패하였습니다. 다시 시도해주십시오');
          }
        );
  
        setTimeout(
            ble.stopScan,
            1500,
            function(){
              $scope.$apply(function(){
                vm.devices = devices;
              });
            },
            function(){
              // Stopping scan failed
            }
        );
  
      };
  
      vm.deviceConnect = function(device_id){
        ble.connect(
          device_id,
          function(res){
            alert(device_id);
          },
          function(err){
            alert(err);
          }
        );
      };
  
      vm.deviceScan();
    }, false);
  }
  // bluetooth end

  vm.langs = [{
    id: 'ko',
    name: '한글'
  }, {
    id: 'en',
    name: '영어'
  }]; // 언어 목록
  vm.selectedLang = vm.langs[0];
  vm.emails = [{
    id: 'direct',
    name: '직접입력',
    value: ''
  }, {
    id: 'naver',
    name: '네이버',
    value: 'naver.com'
  }, {
    id: 'daum',
    name: '다음',
    value: 'daum.net'
  }, {
    id: 'hanmail',
    name: '한메일',
    value: 'hanmail.net'
  }, {
    id: 'gmail',
    name: '지메일',
    value: 'gmail.com'
  }]; // 이메일 제공업체 목록
  vm.selectedEmail = vm.emails[0];
  vm.continents = null; // 대륙 목록
  vm.selectedContinent = null;
  vm.countries = null; // 국가 목록
  vm.selectedCountry = null;
  vm.sports = null; // 종목 목록
  vm.selectedSport = null;
  vm.userTypes1 = null; // 신분 1단계 목록
  vm.selectedUserType1 = null;
  vm.userTypes2 = null; // 신분 2단계 목록
  vm.selectedUserType2 = null;
  vm.teams1 = null; // 팀 1단계 목록
  vm.selectedTeam1 = null;
  vm.teams2 = null; // 팀 2단계 목록
  vm.selectedTeam2 = null;
  vm.teams3 = null; // 팀 3단계 목록
  vm.selectedTeam3 = null;
  vm.team4 = null; //팀 4단계 목록
  vm.selectedTeam4 = null;
  vm.positions1 = null; // 포지션 1단계 목록
  vm.selectedPosition1 = null;
  vm.positions2 = null; // 포지션 2단계 목록
  vm.selectedPosition2 = null;
  vm.years = _.range(1940, currentYear);
  vm.months = _.range(1, 13);
  vm.dates = _.range(1, 32);
  vm.back_numbers = _.range(1, 100);
  vm.licenses = null;
  vm.selectedLicense = null;
  vm.movements1 = null; // 동작 1단계 목록
  vm.selectedMovement1 = null;
  vm.movements2 = null; // 동작 2단계 목록
  vm.selectedMovement2 = null;
  vm.movements3 = null; // 동작 3단계 목록
  vm.selectedMovement3 = null;
  vm.apiUrlRestRoot = AppSettings.apiUrl.restRoot;

  // 카드형태로 표시되는 선수, 관계자, 팀들의 배열
  vm.members = [];

  // 회원가입 데이터
  vm.joinData = {};

  function resetJoinData() {
    vm.joinData = {
      //appr_id: 'ceo@sa21c.com',   // 회원가입시 자동승인되도록 처리, 추후 수정해야 함 => 선수는 자동승인 안되게 막음
      lang_id: null,
      email: {
        first: null,
        second: null
      },
      // login_id: null,
      isDuplicate: null,
      passwd: null,
      name: null,
      gender: 'M',
      birthdate: {
        year: '' + (currentYear - 20),
        month: '01',
        date: '01'
      },
      birth_date: null,
      image_url: null,
      min1: '010',
      min2: null,
      min3: null,
      code: null,
      verify_code: null,
      phone1: '02',
      phone2: null,
      phone3: null,
      addr: {
        zip: null,
        detail: null
      },
      address: null,
      country_id: null,
      height: null,
      weight: null,
      blood_type: 'A',
      sport_id: null,
      user_type_id: null,
      team_id: null,
      position_id: null,
      back_number: '1',
      license_id: null,
      info_agree_flag: 'N'
    };

    if ($stateParams.target != 'OtherTeamPlayer') {
      vm.joinData.team_id = vm.appContext.info.team_id;
    } else {
      vm.joinData.team_id = (vm.oppo_team ? vm.oppo_team.team_id : null);
    }

    if ($stateParams.target.indexOf('Player') != -1) {
      vm.joinData.user_type_id = '1';
    }
  }

  // 자격증 목록 불러오기
  UserService.getLicenses().then(function (res) {
    var data = res.data;
    vm.licenses = data.list;
  }).catch(function(err) {
    console.log(err);
  });

  resetJoinData();  // 회원가입 데이터 초기화

  vm.initForm = function () {
    resetJoinData();

    vm.joinData.passwd = null;
    vm.joinData.confirmed_passwd = null;
    vm.joinData.country_id = vm.appContext.user.country_id;

    vm.joinData.image_url = './images/users/1512045048.7331789.png';

    if ($stateParams.target != 'OtherTeamPlayer') {
      vm.joinData.team_id = vm.appContext.info.team_id;
    } else {
      vm.joinData.team_id = (vm.oppo_team ? vm.oppo_team.team_id : null);
    }

    if ($stateParams.target.indexOf('Player') != -1) {
      vm.joinData.user_type_id = '1';
    }
  }
  // if (vm.isDebugger) {


  // 신분 1단계 변경




  var getUserTypes2 = function (userType1) {
    UserService.getUserTypes({
      parent_id: userType1
    }).then(function (res) {
      vm.userTypes2 = res.data.list;
    }).catch(function(err) {
      console.log(err);
    });

  }

  if ($stateParams.target === 'MyInfo') {
    // userType1 = 2;
    getUserTypes2(vm.appContext.info.parent_user_type_id);
  }

  // var userType1;
  if ($stateParams.target === 'CoachingStep') {
    // userType1 = 2;
    getUserTypes2(2)
  }
  if ($stateParams.target === 'TeamStep') {
    // userType1 = 3;
    getUserTypes2(3)
  }

  vm.myTeamInfo = {};
  UserService.teamInfo({
    id: vm.appContext.info.team_id
  }).then(function (res) {
    vm.myTeamInfo = res.data;

    vm.uploadEmblemData.image_url = vm.myTeamInfo.image_url;
  });

  vm.adminTeamInfo = {};
  if ($stateParams.manager_admin_team_id) {
    UserService.teamInfo({
      id: $stateParams.manager_admin_team_id
    }).then(function (res) {
      vm.adminTeamInfo = res.data;

      vm.uploadEmblemData.image_url = vm.adminTeamInfo.image_url;
    });
  }

  // 팀생성 데이터
  vm.createData = {
    login_id: null,
    uuid: null,
    menu_id: 22,
    parent_id: null,
    country_id: null,
    name: null,
    input_id: null,
    image_url: null,
    stadium_id: null,
    mode: 'N'
  };

  // 팀생성
  vm.createTeam = function () {
    console.log('create team.');

    if (!vm.selectedTeamCountry) {
      toastr.error('국가를 선택하십시오');
      return;
    }

    if (!vm.selectedTeam3) {
      toastr.error('상위 구분을 선택하십시오');
      return;
    }

    if (!vm.createData.name) {
      toastr.error('팀 이름을 입력하십시오');
      return;
    }

    if (!vm.parentStadium.id) {
      toastr.error('홈구장의 지역을 선택하십시오');
      return;
    }

    if (!vm.parentStadium.id) {
      toastr.error('홈구장을 선택하십시오');
      return;
    }

    // 팀생성을 위해서 팀생성 권한이 있는 계정으로 로그인해서 uuid 를 받아옴
    UserService.login({
      login_id: 'team_manager@kfa.or.kr',
      passwd: 'sa21c'
    }).then(function (res) {
      // 팀생성
      vm.createData.login_id = res.data.login_id;
      vm.createData.uuid = res.data.uuid;
      vm.createData.parent_id = vm.selectedTeam3.id;
      vm.createData.country_id = vm.selectedTeamCountry.id;
      vm.createData.input_id = vm.createData.name;
      //vm.createData.image_url = '/images/users/1514709678.2904408.png';

      TeamService.adminManageTeam(vm.createData)
        .then(function (res) {
          if (res.data.result === 'SUC') {
            toastr.success('팀이 생성되었습니다.');
          }
        })
        .catch(function (error) {
          console.log('ERROR', error)
        });
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 팀엠블럼 등록 데이터
  vm.uploadEmblemData = {
    menu_id: 22,
    image_url: ($stateParams.manager_admin_team_id ? vm.adminTeamInfo.image_url : vm.myTeamInfo.image_url),
    stadium_id: null,
    team_id: ($stateParams.manager_admin_team_id ? $stateParams.manager_admin_team_id : vm.appContext.info.team_id),
    mode: 'M'
  };

  // 팀 엠블럼 등록
  vm.uploadTeamEmblem = function() {
    if (!vm.uploadEmblemData.team_id) {
      toastr.error('팀을 선택하십시오');
      return;
    }

    if (!vm.uploadEmblemData.image_url) {
      toastr.error('팀엠블렘을 선택하십시오');
      return;
    }

    // 팀생성을 위해서 팀생성 권한이 있는 계정으로 로그인해서 uuid 를 받아옴
    UserService.login({
      login_id: 'team_manager@kfa.or.kr',
      passwd: 'sa21c'
    }).then(function (res) {
      // 팀생성
      vm.uploadEmblemData.login_id = res.data.login_id;
      vm.uploadEmblemData.uuid = res.data.uuid;
      vm.uploadEmblemData.parent_id = ($stateParams.manager_admin_team_id ? $stateParams.team3_id : vm.appContext.info.parent_team_id);
      vm.uploadEmblemData.country_id = ($stateParams.manager_admin_team_id ? vm.adminTeamInfo.country_id : vm.appContext.info.country_id);
      vm.uploadEmblemData.name = ($stateParams.manager_admin_team_id ? vm.adminTeamInfo.name : vm.appContext.info.team_name);
      vm.uploadEmblemData.input_id = ($stateParams.manager_admin_team_id ? vm.adminTeamInfo.name : vm.appContext.info.team_name);

      TeamService.adminManageTeam(vm.uploadEmblemData)
        .then(function (res) {
          if (res.data.result === 'SUC') {
            toastr.success('엠블렘이 등록되었습니다.');
          }
        })
        .catch(function (error) {
          console.log('ERROR', error)
        });
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 팀삭제 데이터
  vm.removeData = {
    login_id: null,
    uuid: null,
    menu_id: 11,
    parent_id: null,
    country_id: null,
    team_id: null,
    mode: 'R'
  };

  // 팀삭제
  vm.removeTeam = function (teamId) {
    console.log('remove team.');

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '선택한 팀을 삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 팀생성을 위해서 팀생성 권한이 있는 계정으로 로그인해서 uuid 를 받아옴
            UserService.login({
              login_id: 'team_manager@kfa.or.kr',
              passwd: 'sa21c'
            }).then(function (res) {
              // 팀생성
              vm.removeData.login_id = res.data.login_id;
              vm.removeData.uuid = res.data.uuid;
              vm.removeData.parent_id = vm.selectedTeam3.id;
              vm.removeData.country_id = vm.selectedTeamCountry.id;
              vm.removeData.team_id = teamId;

              TeamService.adminManageTeam(vm.removeData)
                .then(function (res) {
                  if (res.data.result === 'SUC') {
                    toastr.success('팀이 삭제되었습니다.');

                    // 페이지 정보 새로 로드
                    $state.go('Service.member', $stateParams, { reload: true });
                  }
                })
                .catch(function (error) {
                  console.log('ERROR', error)
                });
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  }

  // 선수로 로그인한 경우 개인 정보 불러옴
  var getPlayer = function () {
    UserService.info({
      'user_id': vm.appContext.user.user_id
    }).then(function (res) {
      vm.appContext.user.name = res.data.name;  // 화면 좌측 상단의 이름을 갱신

      var myInfo = res.data;
      myInfo.user_id = vm.appContext.user.user_id;

      vm.members = [myInfo];
    }).catch(function(err) {
      console.log(err);
    });

    // 이적 요청
    UserService.reqList({
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      mode: 'T'
    }).then(function(res) {
      vm.myTransferReqList = res.data.list;
    }).catch(function(err) {
      console.log(err);
    });
    // 발탁 요청
    UserService.reqList({
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      mode: 'P'
    }).then(function(res) {
      vm.myPickReqList = res.data.list;
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 선수로 로그인한 경우 발탁된 팀의 일정관리로 이동
  vm.goPickTeam = function(teamId) {
    $state.go('Service.planner', { type_code: 'team', team_id: teamId, fan_team_id: teamId });
  };

  // 선수로 로그인한 경우 선수의 팬들 정보 불러옴
  var getPlayerFans = function (userTypeId) {
    // userTypeId: 17 - 후원팬
    // userTypeId: 28 - 일반팬

    vm.members = [];

    UserService.info({
      'user_id': vm.appContext.user.user_id
    }).then(function (res) {
      console.log('선택 선수', res.data);

      // 선수 정보 조회
      if (res.data.fans && res.data.fans.length) {
        var fans = _.filter(res.data.fans, {
          user_type_id: userTypeId
        });

        _.forEach(fans, function (item) {
          UserService.info({
            'user_id': item.id
          }).then(function (res) {
            res.data.user_id = item.id;
            vm.members.push(res.data);
          });
        });
      }
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 팀관계자로 로그인한 경우 팀의 팬들 정보 불러옴
  var getTeamFans = function (userTypeId, teamId) {
    // userTypeId: 17 - 후원팬
    // userTypeId: 28 - 일반팬

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      teamId = $stateParams.manager_admin_team_id;
    }

    vm.members = [];

    var data = {
      all: 'Y',
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      team_id: teamId
    }

    PlayerService.getPlayers(data).then(function (res) {
      // 선수 정보 조회
      var fans = _.filter(res.data.non_players || [], {
        user_type_id: userTypeId
      });

      UserService.teamInfo({
        id: teamId
      }).then(function (res) {
        _.forEach(res.data.fans, function(item) {
          if (item.user_type_id == userTypeId) {
            fans.push({
              user_id: item.id
            });
          }
        });

        _.forEach(fans, function (item) {
          UserService.info({
            'user_id': item.user_id
          }).then(function (res) {
            res.data.user_id = item.id || item.user_id;
            res.data.fanPlayers = [];
            vm.members.push(res.data);
            
            var usersIds = res.data.users_ids.split(',');
            _.forEach(usersIds, function(item2) {
              if (+item2) {
                UserService.info({
                  'user_id': item2
                }).then(function (res2) {
                  res.data.fanPlayers.push(res2.data);
                });
              }
            });
          });
        });
      }).catch(function(err) {
        console.log(err);
      });
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 팬으로 로그인한 경우 팬의 선수들 정보 불러옴
  var getFanPlayers = function () {
    vm.members = [];

    UserService.info({
      'user_id': vm.appContext.user.user_id
    }).then(function (res) {
      console.log('선택 선수', res.data.users_ids);

      // 선수 정보 조회
      _.forEach((res.data.users_ids).split(','), function (item) {
        UserService.info({
          'user_id': item
        }).then(function (res) {
          res.data.user_id = item;
          vm.members.push(res.data);
        });
      });
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 팬으로 로그인해서 팀구성 메뉴로 들어온 경우
  var getTeams = function () {
    vm.members = [];

    UserService.info({
      'user_id': vm.appContext.user.user_id
    }).then(function (res) {
      console.log('선택 팀', res.data.teams_ids);

      // 팀 정보 조회
      _.forEach((res.data.teams_ids).split(','), function (item) {
        UserService.teamInfo({
          id: item
        }).then(function (res) {
          // 팀의 감독, 팀매니저를 찾아서 결제 받는 사람 아이디로 사용
          var data = {
            all: 'Y',
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            team_id: item
          }
          
          PlayerService.getPlayers(data)
            .then(function (res2) {
              // 감독
              var obj = _.find(res2.data.non_players, {
                user_type_id: 4
              });
              if (!obj) {
                // 팀매니저
                obj = _.find(res2.data.non_players, {
                  user_type_id: 12
                });
              }

              res.data.id = item;   // team id 추가
              res.data.is_team = true;
              if (obj) {
                res.data.team_pay_id = obj.user_id;
              }

              // 팀의 감독, 팀매니저 아이디를 찾아서 payed 조회
              UserService.info({
                'user_id': res.data.team_pay_id
              }).then(function (res3) {
                res.data.payed = res3.data.payed;

                // 화면 후원팀 목록에 표시될 데이터 생성
                vm.members.push(res.data);
              }).catch(function(err) {
                console.log(err);
              });
            }).catch(function(err) {
              console.log(err);
            });
        });
      });
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 감독-선수 소속팀 관련 수정
  // 감독-선수로 로그인해서 소속팀 메뉴로 들어온 경우
  var getCoachPlayerTeams = function () {
    vm.members = [];

    UserService.info({
      'user_id': vm.appContext.user.user_id
    }).then(function (res) {
      console.log('선택 팀', res.data.teams_ids);

      // 팀 정보 조회
      _.forEach((res.data.teams_ids).split(','), function (item) {
        UserService.teamInfo({
          id: item
        }).then(function (res) {
          // 화면 소속팀 목록에 표시될 데이터 생성
          res.data.id = item;
          vm.members.push(res.data);
        });
      });
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 구단주나 단장으로 로그인해서 팀구성 메뉴로 들어온 경우
  var getOwnerTeams = function() {
    var myTeamsData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid
    };
    
    // 구단주, 단장이 보유한 팀 목록
    UserService.myTeams(myTeamsData).then(function(res) {
      _.forEach(res.data.list, function(item) {
        UserService.login({
          login_id: item.login_id,
          passwd: item.passwd
        }).then(function (res2) {
          console.log(item.team_id, item.team_name, res2.data.login_id, res2.data.user_id, res2.data.uuid);
          
          // 팀 정보 조회
          UserService.teamInfo({
            id: item.team_id
          }).then(function (res3) {
            res3.data.id = item.team_id;   // team id 추가
            res3.data.user_type_id = vm.appContext.user.user_type_id;
            res3.data.login_id = res2.data.login_id;
            res3.data.uuid = res2.data.uuid;
            vm.members.push(res3.data);
          });
        }).catch(function(err) {
          console.log(err);
        });
      });
    }).catch(function(err) {
      console.log(err);
    });
  };

  var getPlayers = function (team_id, isAdmin, mode) {
    console.log(team_id);

    // 본인정보 메뉴로 들어온 경우
    if ($stateParams.target === 'MyInfo') {
      getPlayer();
      return;
    }
    // 선수로 로그인해서 선수구성 메뉴로 들어온 경우
    else if (vm.appContext.role2 === 'player' && $stateParams.target === 'MyTeamPlayer') {
      getPlayer();
      return;
    }
    // 선수로 로그인해서 후원관리 메뉴로 들어온 경우
    else if (vm.appContext.role2 === 'player' && $stateParams.target === 'MyFans') {
      getPlayerFans(17);
      return;
    }
    // 선수로 로그인해서 일반관리 메뉴로 들어온 경우
    else if (vm.appContext.role2 === 'player' && $stateParams.target === 'MyFans2') {
      getPlayerFans(28);
      return;
    }
    // 팀스텝으로 로그인해서 후원관리 메뉴로 들어온 경우
    else if ((vm.appContext.role2 === 'team_staff' || vm.appContext.role2 === 'sa21c') && $stateParams.target === 'TeamSponsors') {
      getTeamFans(17, $stateParams.team_id);
      return;
    }
    // 팀스텝으로 로그인해서 일반관리 메뉴로 들어온 경우
    else if ((vm.appContext.role2 === 'team_staff' || vm.appContext.role2 === 'sa21c') && $stateParams.target === 'TeamSponsors2') {
      getTeamFans(28, $stateParams.team_id);
      return;
    }
    // 팬으로 로그인해서 선수구성 메뉴로 들어온 경우
    else if (vm.appContext.role2 === 'fan' && $stateParams.target === 'MyTeamPlayer') {
      getFanPlayers();
      return;
    }
    // 팬으로 로그인해서 팀구성 메뉴로 들어온 경우
    else if (vm.appContext.role2 === 'fan' && $stateParams.target === 'MyTeam') {
      getTeams();
      return;
    }
    // 감독-선수 소속팀 관련 수정
    // 감독-선수로 로그인해서 소속팀 메뉴로 들어온 경우
    else if (vm.appContext.role3 === 'coach_player' && $stateParams.target === 'MyTeam') {
      getCoachPlayerTeams();
      return;
    }
    // 구단주나 단장으로 로그인해서 소유팀 메뉴로 들어온 경우
    else if ((vm.appContext.user.user_type_id == 355 || vm.appContext.user.user_type_id == 10) && $stateParams.target === 'MyTeam') {
      getOwnerTeams();
      return;
    }

    var data = {
      all: 'Y',
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // team_id: team_id
    }
    
    if ($stateParams.target != 'OtherTeamPlayer') {
      if (isAdmin) {
        data.team_id = team_id;
      } else {
        data.team_id = vm.appContext.info.team_id;
      }
    } else {
      data.team_id = (vm.oppo_team ? vm.oppo_team.team_id : null);
    }

    // 선수 목록 불러오는데 사용한 team_id 를 선수등록, 정보수정에 사용
    vm.joinData.team_id = data.team_id;

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      data.team_id = $stateParams.manager_admin_team_id;
    }

    if (mode === 'Scout') {
      data.team_id = vm.selectedTeam4.id;
    }

    // 감독-선수 소속팀 관련 수정
    if ($stateParams.coach_player_team_id) {
      data.team_id = $stateParams.coach_player_team_id;
    }

    PlayerService.getPlayers(data)
      .then(function (res) {

        // var data = res.data;
        // var data = temp_data;
        // if ($stateParams.target === 'OtherTeamPlayer') {
        //   data = res.data;
        // }
        // // console.log(data)
        // if ($stateParams.target === 'CoachingStep') {
        //   vm.members = _.filter(temp_data.non_players, {
        //     'parent_user_type_id': 2
        //   });
        // } else if ($stateParams.target === 'TeamStep') {
        //   vm.members = _.filter(temp_data.non_players, {
        //     'parent_user_type_id': 3
        //   });
        // } else if ($stateParams.target === 'Finance') {
        //   vm.members = data.players.concat(data.non_players);
        //   console.log(data, vm.members)
        // } else {
        //   vm.members = data.players;
        // }

        if ($stateParams.target === 'CoachingStep') {
          // 지도자로 로그인한 경우
          if (vm.appContext.user.role2 === 'coaching_staff') {
            // 로그인한 본인 정보 및 자신 보다 높은 권한을 제외한 코치들의 목록 보기
            // => user_type_id 가 본인 정보의 user_type_id 보다 큰 코치들 목록만 보이게 함
            // ==> user_type_id 로 권한이 높고 낮음을 판단하는 것이 변경될 수 있음
            vm.members = _.reject(_.filter(res.data.non_players, {
              'parent_user_type_id': 2
            }), function(item) {
              return item.user_type_id <= vm.appContext.user.user_type_id;
            });
          }
          else {
            // 로그인한 본인 정보는 빼고 보여줌
            vm.members = _.reject(_.filter(res.data.non_players, {
              'parent_user_type_id': 2
            }), {
              user_id: '' + vm.appContext.user.user_id
            });
          }
        } else if ($stateParams.target === 'TeamStep') {
          // 로그인한 본인 정보는 빼고 보여줌
          vm.members = _.reject(_.filter(res.data.non_players, {
            'parent_user_type_id': 3
          }), {
            user_id: '' + vm.appContext.user.user_id
          });

          // 구단주나 단장에게 팀을 지정할 때, 시스템이 생생하는 사용자는 빼고 보여줌
          vm.members = _.reject(vm.members, {
            name: 'SYSTEM_MADE'
          });

          _.forEach(vm.members, function(owner) {
            _.forEach((owner.teams_ids).split(','), function (item) {
              owner.teamNames = [];
              UserService.teamInfo({
                id: item
              }).then(function (res) {
                owner.teamNames.push(res.data.name);
              }).catch(function(err) {
                console.log(err);
              });
            });
          });
        }
        // 영입대상
        else if ($stateParams.target === 'Scout' && mode !== 'Scout') {

          // 영입대상 메뉴에서는
          // 영입대상을 요청한 목록 보여주기
          // 영입대상을 받은 목록 보여주기

          var requestListMode;

          // 현재 사용자가 국가 대표팀 소속 팀 관계자 / 감독인지 여부 - 추후 수정되어야 함
          if (
            ($stateParams.manager_admin_team_id && vm.appContext.my_team && vm.appContext.my_team.team_name === 'National Team') ||
            (vm.appContext.info.team_name === 'National Team' && (vm.appContext.user.user_type_id === '4' || vm.appContext.user.user_type_id === '10' || vm.appContext.user.user_type_id === '12' || vm.appContext.user.user_type_id === '22' ))
          ) {
            requestListMode = 'P';
          } else {
            requestListMode = 'T';
          }

          var reqListData = {
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            mode: requestListMode
          };

          // 영입대상을 요청한 목록
          UserService.reqList(reqListData).then(function(res) {
            _.forEach(res.data.list, function(item) {
              UserService.info({
                'user_id': item.user_id
              }).then(function (res2) {
                vm.members.push($.extend({}, item, res2.data));
              }).catch(function(err) {
                console.log(err);
              });
            });
          });
          
          // 영입대상을 받은 목록
          _.forEach(res.data.players, function(item) {
            //vm.members.push(item);
          });
        }
        // 재무관리 화면에 표시할 샘플 데이터
        else if ($stateParams.target === 'Finance') {
          vm.members = [{
            "name": "정몽규",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "회장",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "홍명보",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "단장",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "전한진",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "사무국장",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "신태용",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "감독",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "김남일",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "수석코치",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "차두리",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type": "코치",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "이재성",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type_id": "1",
            "back_number": "17",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "손흥민",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type_id": "1",
            "back_number": "7",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }, {
            "name": "고요한",
            "approved": true,
            "image_url": "./images/users/1512045048.7331789.png",
            "user_type_id": "1",
            "back_number": "14",
            "생년월일": "1977.12.12",
            "계약일": "2016.12.12",
            "전적": "56전 40승 10무 6패",
            "승률": "89%",
            "상승비율": "120%",
            "예상연봉": "1,230,000,000",
            "예상수당": "21,000,000"
          }];
        } else {
          // 상대팀 선수목록 보기이면서 팀 선택 표시가 보여지지 않은 상태인 경우
          if ($stateParams.target === 'OtherTeamPlayer' && !vm.isTeamChange) {
            return;
          }

          console.log(res.data.players);
          // 로그인한 본인 정보는 빼고 보여줌

          if (mode === 'Scout') {
            vm.members2 = _.reject(res.data.players, {
              user_id: '' + vm.appContext.user.user_id
            });
          } else {
            vm.members = _.reject(res.data.players, {
              user_id: '' + vm.appContext.user.user_id
            });
          }
        }

        _.forEach(vm.members, function(item) {
          UserService.info({
            'user_id': item.user_id
          }).then(function (res2) {
            _.forEach(res2.data, function(value, key) {
              item[key] = value;
            });
          }).catch(function(err) {
            console.log(err);
          });  
        });


      })
      .catch(function (error) {
        console.log('ERROR ', error)
      });
  }

  if ($stateParams.team_id && 
      //!(vm.appContext.role2 === 'sa21c' && $stateParams.team_id == '0' && $stateParams.target !== 'MyInfo') &&
      !(vm.appContext.role2 === 'sa21c' && !$stateParams.team1_id)
    ) {
    getPlayers($stateParams.team_id);
  }


  // var getUserList = function () {
  //   let params = {
  //     login_id: vm.appContext.user.login_id,
  //     uuid: vm.appContext.user.uuid,
  //     limit: 100,
  //     page: 1,
  //     team_id: '72',
  //     step2: 'Y'
  //   };
  //   UserService.getUserList(params).then(function (res) {
  //     // vm.other_team.players = res.data.list;
  //     vm.my_team.players = res.data.list;
  //   });

  // }

  // if ($stateParams.target == 'OtherTeamPlayer') {
  // getUserList();
  // }




  vm.userRelease = function (user_id, type) {
    vm.userReleasePasswd = null;

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까? <input type="password" ng-model="vm.userReleasePasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              user_id: user_id,
              passwd: vm.userReleasePasswd
            }

            UserService.release(data).then(function (res) {
              if (res.data.result == 'SUC') {
                toastr.success('삭제 하였습니다.');
                getPlayers();
              } else if (res.data.result == 'TEAM_MISMATCH') {
                toastr.error('팀이 일치하지 않습니다.');
              } else if (res.data.result == 'PASSWD_MISMATCH') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });


  }

  vm.userApprove = function (login_id, type) {
    vm.userApprovePasswd = null;

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '승인확인',
      content: '이 선수가 당신의 선수가 맞습니까? <input type="password" ng-model="vm.userApprovePasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '승인',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              appr_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              login_id: login_id,
              passwd: vm.userApprovePasswd
            }

            UserService.approve(data).then(function (res) {
              console.log(res);
              if (res.data.result == 'SUC') {
                toastr.success('승인되었습니다!')
                getPlayers();
              } else if (res.data.result == 'PASSWD_MISMATCH') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  vm.userApproveCancel = function (login_id, type) {
    vm.userApprovePasswd = null;

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '승인취소',
      content: '승인을 취소하시겠습니까? <input type="password" ng-model="vm.userApprovePasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '승인취소',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              appr_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              login_id: login_id,
              cancel: 'Y',
              passwd: vm.userApprovePasswd
            }

            UserService.approve(data).then(function (res) {
              console.log(res);
              if (res.data.result == 'SUC') {
                toastr.success('승인이 취소되었습니다!')
                getPlayers();
              } else if (res.data.result == 'PASSWD_MISMATCH') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };



  // 회원 가입
  vm.saveUser = function (remove, fanTeamRemove) {


    vm.joinData = _.pickBy(vm.joinData, _.identity);

    if (fanTeamRemove) {
      vm.joinData.teams_ids = '';
    }

    if (!vm.joinData.user_type_id) {
      toastr.error('구분을 선택하세요.');
      return;
    }

    if (!vm.joinData.team_id) {
      toastr.error('팀설정 오류 입니다. 팀을 선택 후 가입해주십시오');
      return;
    }

    if (!(+vm.joinData.position_id) && vm.joinData.user_type_id == 1) {
      toastr.error('포지션을 선택하세요.');
      return;
    }

    if (vm.isEditMode) {
      vm.joinData.login_id = vm.appContext.user.login_id;
      vm.joinData.uuid = vm.appContext.user.uuid;
      // vm.joinData.user_id = 


      // console.log('edit', vm.joinData);
      // return;
      console.log(vm.joinData);
      UserService.modify(vm.joinData)
        .then(function (res) {
          if (res.data.result === 'SUC') {
            toastr.success(remove ? '삭제 하였습니다!' : '저장 하였습니다!');
            if (vm.appContext.role2 === 'sa21c') {
              // 페이지 정보 새로 로드
              $state.go('Service.member', $stateParams, { reload: true });
            } else {
              getPlayers(vm.joinData.team_id);
            }
            
            vm.showModal = false;
          } else {
            let message;
            switch (res.data.result) {
              case 'DUP':
                message = '사용 중인 아이디입니다.';
                break;
              case 'EXP':
                message = '관리자 세션 정보가 불일치합니다.'
                break;
              case 'TEAM_NO_MATCH':
                message = '관리자 팀과 개인 팀이 불일치합니다.'
                break;
              case 'REJECTED':
                message = '승인 거절된 팀/협회/회사/일반 입니다.';
                break;
              case 'NO_CODE_INPUT':
                message = '이메일 인증코드 입력값이 없습니다.'
                break;
              case 'NO_CODE':
                message = '인증메일 발송을 해주십시오';
                break;
              case 'CODE_MISMATCH':
                message = '이메일 인증코드를 받은 이메일 주소와 가입하시려는 이메일 주소가 다릅니다.';
                break;
              case 'DUP_BACK_NUMBER':
                message = '같은 배번의 선수가 등록되어 있습니다. 다른 배번을 선택해주십시오';
                break;
              case 'DUP_USER_TYPE':
                message = '같은 회원 구분이 이미 팀에 등록되어 있어서 수정하실 수 없습니다.';
                break;
              default:
                message = '회원가입 중 오류가 발생하였습니다.';
                break;
            }
            toastr.error(message);
          }
        })
        .catch(function (error) {
          console.log('ERROR', error);
        });

    } else {

      let month;
      let date;
      if (!vm.joinData.birth_date) {
        month = vm.joinData.birthdate.month;
        date = vm.joinData.birthdate.date;

        if (month < 10) {
          month = '0' + +month;
        }
        if (date < 10) {
          date = '0' + +date;
        }

        vm.joinData.birth_date = vm.joinData.birthdate.year + month + date;
      }

      if (vm.joinData.user_type_id == '1') {
        // 선수의 경우 자동승인 안되게 막음
        vm.joinData.appr_id = null;
      }

      //vm.joinData.my_login_id = vm.appContext.user.login_id;  // 상대팀 선수 등록시에만 입력
      //vm.joinData.my_uuid = vm.appContext.user.uuid;      // 상대팀 선수 등록시에만 입력

      UserService.join(vm.joinData)
        .then(function (res) {
          if (res.data.result === 'SUC') {
            toastr.success(remove ? '삭제 하였습니다!' : '저장 하였습니다!');
            getPlayers(vm.joinData.team_id);
            vm.showModal = false;
          } else {
            let message;
            switch (res.data.result) {
              case 'DUP':
                message = '사용 중인 아이디입니다.';
                break;
              case 'EXP':
                message = '관리자 세션 정보가 불일치합니다.'
                break;
              case 'TEAM_NO_MATCH':
                message = '관리자 팀과 개인 팀이 불일치합니다.'
                break;
              case 'REJECTED':
                message = '승인 거절된 팀/협회/회사/일반 입니다.';
                break;
              case 'NO_CODE_INPUT':
                message = '이메일 인증코드 입력값이 없습니다.'
                break;
              case 'NO_CODE':
                message = '인증메일 발송을 해주십시오';
                break;
              case 'CODE_MISMATCH':
                message = '이메일 인증코드를 받은 이메일 주소와 가입하시려는 이메일 주소가 다릅니다.';
                break;
              case 'DUP_BACK_NUMBER':
                message = '같은 배번의 선수가 등록되어 있습니다. 다른 배번을 선택해주십시오';
                break;
              case 'DUP_USER_TYPE':
                message = '같은 회원 구분이 이미 팀에 등록되어 있어서 가입하실 수 없습니다.';
                break;
              default:
                message = '회원가입 중 오류가 발생하였습니다.';
                break;
            }
            toastr.error(message);
          }
        })
        .catch(function (error) {
          console.log('ERROR', error);
        });
    }

  };

  /**
   * 유저정보 수정
   */
  vm.userEdit = function (user_id) {
    // console.log(user_id);       


    let team_id = null;

    if ($scope.addUser == true) { //접속자팀 선수 세팅
      team_id = vm.adminUser.team_id;
    } else { //상대팀 선수 세팅
      team_id = vm.joinData.team_id;
    }

    if ($stateParams.manager_admin_team_id) {
      team_id = $stateParams.manager_admin_team_id;
    }

    // 국가, 혈액형, 종목, 사용발, 신분, 포지션, 배번 변경

    UserService.info({
      'user_id': user_id
    }).then(function (res) {
      console.log('선택선수 : ', res);

      vm.showModal = true;

      vm.joinData = {
        user_id: user_id,
        login_id: res.data.login_id,
        my_login_id: null,  // 상대팀 선수 등록시에만 입력
        my_uuid: null,      // 상대팀 선수 등록시에만 입력
        name: res.data.name,
        gender: res.data.gender,
        birthdate: {
          year: res.data.birth_date.substr(0, 4),
          month: res.data.birth_date.substr(4, 2),
          date: res.data.birth_date.substr(6, 2)
        },
        birth_date: res.data.birth_date,
        image_url: res.data.image_url,
        min1: res.data.min1,
        min2: res.data.min2,
        min3: res.data.min3,
        code: null,
        verify_code: null,
        // phone1: res.data.phone1,
        // phone2: res.data.phone2,
        // phone3: res.data.phone3,
        // addr: {
        //   zip: null,
        //   detail: null
        // },
        // address: res.data.address,
        country_id: res.data.country_id,
        height: res.data.height,
        weight: res.data.weight,
        blood_type: res.data.blood_type,
        sport_id: res.data.sport_id,
        user_type_id: +res.data.user_type_id,
        user_type_obj: _.find(res.data.user_type_list, {
          id: +res.data.user_type_id
        }),
        team_id: team_id,
        team_name: res.data.team_name,
        position_id: res.data.position_id,
        back_number: res.data.back_number,
        movement00_id: res.data.movement00_id,
        movement0_id: res.data.movement0_id,
        movement_id: res.data.movement_id,
        license_list: res.data.license_list,
        license_id: res.data.license_id,
        license_no: res.data.license_no,
        using_foot: res.data.using_foot ? res.data.using_foot : 'R',
        info_agree_flag: res.data.info_agree_flag
      };

      // 대륙 매칭



      vm.selectedContinent = _.find(vm.continents, {
        id: Number(res.data.land_id)
      });

      // 종목
      vm.selectedSport = _.find(vm.sports, {
        id: Number(res.data.sport_id)
      });

      // 신분 단계별 파싱
      if (res.data.parent_user_type_id) {
        vm.selectedUserType1 = _.find(vm.userTypes1, {
          id: Number(res.data.parent_user_type_id)
        });
      } else {
        vm.selectedUserType1 = _.find(vm.userTypes1, {
          id: Number(res.data.user_type_id)
        });
      }

      //자격증
      vm.selectedLicense = _.find(vm.licenses, {
        id: Number(res.data.license_id)
      });

      // 포지션
      if (res.data.parent_position_id) {
        vm.selectedPosition1 = _.find(vm.positions1, {
          id: Number(res.data.parent_position_id)
        });
      } else {
        vm.selectedPosition1 = _.find(vm.positions1, {
          id: Number(res.data.position_id)
        });
      }

      // 특기
      if (res.data.movement00_id) {
        vm.selectedMovement1 = _.find(vm.movements1, {
          id: Number(res.data.movement00_id)
        });
      } else {
        vm.selectedMovement1 = _.find(vm.movements1, {
          id: Number(res.data.movement0_id)
        });
      }


    })
      .catch(function (error) {
        console.log('ERROR', error);
      });
  }

  UserService.getCountries().then(function (res) {
    vm.continents = res.data.list;

    vm.selectedTeamContinent = vm.continents[0];
  }).catch(function(err) {
    console.log(err);
  });


  UserService.getSports().then(function (res) {
    vm.sports = res.data.list;
    vm.selectedSport = vm.sports[0];
  }).catch(function(err) {
    console.log(err);
  });

  //getPositions
  UserService.getPositions().then(function (res) {
    vm.positions1 = res.data.list;
    vm.selectedPosition1 = vm.positions1[0];
  }).catch(function(err) {
    console.log(err);
  });



  // 대륙 변경
  $scope.$watch('vm.selectedTeamContinent', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      vm.countries = null;
      vm.teams1 = null;
      vm.teams2 = null;
      vm.teams3 = null;
      vm.teams4 = null;

      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {

        vm.countries = res.data.list;

        vm.selectedTeamCountry = vm.countries[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 국가 변경
  var country_id;
  var country_name;
  $scope.$watch('vm.selectedTeamCountry', function (newVal, oldVal) {
    if (newVal) {

      vm.teams1 = null;
      vm.teams2 = null;
      vm.teams3 = null;
      vm.teams4 = null;

      country_id = newVal.id;
      country_name = newVal.name;



      // vm.joinData.country_id = newVal.id;
      // $rootScope.selectedOppTeam.country = newVal;
      // 초기 팀 목록 불러오기
      UserService.getTeams({
        country_id: newVal.id
      }).then(function (res) {
        // $scope.$apply(function () {
        // });
        vm.teams1 = res.data.list;

        // 이 메뉴에서 단체는 필요하지 않아서 삭제
        _.remove(vm.teams1, {
          name: '단체'
        });

        vm.selectedTeam1 = vm.teams1[0];
        // $rootScope.selectedOppTeam.selectedTeam1 = vm.teams1[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });



  // 팀 1단계 변경
  $scope.$watch('vm.selectedTeam1', function (newVal, oldVal) {

    vm.teams2 = null;
    vm.teams3 = null;
    vm.teams4 = null;

    if (newVal && !newVal.is_last) {
      // console.log('1111')
      // $rootScope.selectedOppTeam.selectedTeam1 = newVal;
      // let country_id = $rootScope.selectedOppTeam.country.id;
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams2 = res.data.list;
        // vm.selectedTeam2 = vm.teams2[0];
        // $rootScope.selectedOppTeam.selectedTeam2 = vm.teams2[0];
      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        console.log('2222')
        // vm.joinData.team_id = newVal.id;
        // $rootScope.selectedOppTeam.selectedTeam1 = newVal;
        // let params = {
        //   login_id: vm.adminUser.login_id,
        //   uuid: vm.adminUser.uuid,
        //   limit: 100,
        //   page: 1,
        //   team_id: newVal.id,
        //   step2: 'Y'
        // }
        // UserService.getUserList(params).then(function (data) {
        //   // console.log('oppTeamPlayer : ', data);
        //   if (data.list.length > 0) {
        //     setOppPlayers(data);
        //   }
        // });
      }

    }
  });

  // 팀 2단계 변경
  $scope.$watch('vm.selectedTeam2', function (newVal, oldVal) {
    vm.teams3 = null;
    vm.teams4 = null;
    // $scope.$parent.base.oppPlayers = [];
    // let country_id = $rootScope.selectedOppTeam.country.id;
    if (newVal && !newVal.is_last) {
      // $rootScope.selectedOppTeam.selectedTeam2 = newVal;
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        // $scope.$apply(function () {
        // });
        vm.teams3 = res.data.list;
        // vm.selectedTeam3 = vm.teams3[0];
        // $rootScope.selectedOppTeam.selectedTeam3 = vm.teams3[0];
      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        vm.joinData.team_id = newVal.id;
        $rootScope.selectedOppTeam.selectedTeam2 = newVal;
        let params = {
          login_id: vm.adminUser.login_id,
          uuid: vm.adminUser.uuid,
          limit: 100,
          page: 1,
          team_id: newVal.id,
          step2: 'Y'
        }
        UserService.getUserList(params).then(function (data) {
          console.log('oppTeamPlayer : ', data);
          // if (data.list.length > 0) {
          //   setOppPlayers(data);
          // }
        }).catch(function(err) {
          console.log(err);
        });
      }

      // vm.teams3 = null;
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.selectedTeam3', function (newVal, oldVal) {
    vm.selectedTeam4 = null;

    if (newVal && !newVal.is_last) {
      // $rootScope.selectedOppTeam.selectedTeam3 = newVal;
      // let country_id = $rootScope.selectedOppTeam.country.id;
      UserService.getTeams({
        country_id: country_id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.teams4 = res.data.list;
        // vm.selectedTeam4 = vm.teams4[0];
        // $rootScope.selectedOppTeam.selectedTeam4 = vm.teams4[0];
      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        vm.joinData.team_id = newVal.id;
        $rootScope.selectedOppTeam.selectedTeam3 = newVal;
        let params = {
          login_id: vm.adminUser.login_id,
          uuid: vm.adminUser.uuid,
          limit: 100,
          page: 1,
          team_id: newVal.id,
          step2: 'Y'
        }
        UserService.getUserList(params).then(function (data) {
          // console.log('oppTeamPlayer : ', data);
          if (data.list.length > 0) {
            setOppPlayers(data);
          }
        }).catch(function(err) {
          console.log(err);
        });
      }

      vm.teams4 = null;
    }
  });

  // 팀 4단계 변경
  var team_name;
  $scope.$watch('vm.selectedTeam4', function (newVal, oldVal) {
    if (newVal) {

      console.log('팀 4단계 newVal', newVal);
      team_name = newVal.name;

      vm.oppo_team = {};
      vm.oppo_team.country_name = country_name;
      vm.oppo_team.team_name = team_name;
      vm.oppo_team.team_id = newVal.id;
      getPlayers(false, false, 'Scout');

    }
  });

  // 팀 선택 초기화
  vm.resetTeams = function () {
    vm.oppo_team = {};
    vm.members2 = [];

    vm.selectedTeam2 = null;
    vm.selectedTeam3 = null;
    vm.selectedTeam4 = null;
  };






  // 생년월일 변경
  $scope.$watchCollection('vm.joinData.birthdate', function (newVal, oldVal) {
    if (newVal && newVal.year && newVal.month && newVal.date) {
      let month = newVal.month;
      let date = newVal.date;

      if (month < 10) {
        month = '0' + +month;
      }
      if (date < 10) {
        date = '0' + +date;
      }

      vm.joinData.birth_date = newVal.year + month + date;
    }
  });

  // 대륙 변경
  $scope.$watch('vm.selectedContinent', function (newVal, oldVal) {
    // console.log('newVal, oldVal', newVal, oldVal);

    if (newVal && !newVal.is_last) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        // $scope.$apply(function () {
        //   vm.countries = data.list;
        //   var isInit = _.find(vm.countries, {
        //     id: Number(vm.joinData.country_id)
        //   });

        //   console.log('isInit', isInit)

        //   if (isInit) {
        //     vm.selectedCountry = isInit;
        //   } else {
        //     vm.selectedCountry = vm.countries[0];
        //   }
        // });

        vm.countries = res.data.list;
        var isInit = _.find(vm.countries, {
          id: Number(vm.joinData.country_id)
        });

        // console.log('isInit', isInit)

        if (isInit) {
          vm.selectedCountry = isInit;
        } else {
          vm.selectedCountry = vm.countries[0];
        }


      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 국가 변경
  $scope.$watch('vm.selectedCountry', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.country_id = newVal.id;
    }
  });

  // 종목 변경
  $scope.$watch('vm.selectedSport', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.sport_id = newVal.id;
    }
  });


  // 신분 2단계 변경
  $scope.$watch('vm.selectedUserType2', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.user_type_id = newVal.id;
    }
  });

  // 사용자 구분 변경
  $scope.$watch('vm.joinData.user_type_obj', function (newVal, oldVal) {
    if (newVal && newVal.id) {
      vm.joinData.user_type_id = newVal.id;
    }
  });

  // 포지션 1단계 변경
  $scope.$watch('vm.selectedPosition1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getPositions({
        parent_id: newVal.id
      }).then(function (res) {
        // $scope.$apply(function () {
        // });

        vm.positions2 = res.data.list;
        var isInit = _.find(vm.positions2, {
          id: Number(vm.joinData.position_id)
        });
        if (isInit) {
          vm.selectedPosition2 = isInit;
        } else {
          vm.selectedPosition2 = vm.positions2[0];
        }


      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        vm.joinData.position_id = newVal.id;
      }

      vm.positions2 = null;
    }
  });

  // 포지션 2단계 변경
  $scope.$watch('vm.selectedPosition2', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.position_id = newVal.id;
    }
  });

  // 자격증 변경
  $scope.$watch('vm.selectedLicense', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.license_id = newVal.id;
    }
  });

  // 동작 1단계 변경
  $scope.$watch('vm.selectedMovement1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getMovements({
        parent_id: newVal.id
      }).then(function (data) {
        $scope.$apply(function () {
          vm.movements2 = data.list;
          if (vm.joinData.movement00_id) {
            var isInit = _.find(vm.movements2, {
              id: Number(vm.joinData.movement0_id)
            });
          } else {
            var isInit = _.find(vm.movements2, {
              id: Number(vm.joinData.movement_id)
            });
          }
          if (isInit) {
            vm.selectedMovement2 = isInit;
          } else {
            vm.selectedMovement2 = vm.movements2[0];
          }
        });
      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        vm.joinData.movement_id = newVal.id;
      }
      vm.movements2 = null;
      vm.movements3 = null;
    }
  });

  // 동작 2단계 변경
  $scope.$watch('vm.selectedMovement2', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getMovements({
        parent_id: newVal.id
      }).then(function (data) {
        $scope.$apply(function () {
          vm.movements3 = data.list;
          var isInit = _.find(vm.movements3, {
            id: Number(vm.joinData.movement_id)
          });
          if (isInit) {
            vm.selectedMovement3 = isInit;
          } else {
            vm.selectedMovement3 = vm.movements3[0];
          }
        });
      }).catch(function(err) {
        console.log(err);
      });
    } else {
      if (newVal) {
        vm.joinData.movement_id = newVal.id;
      }

      vm.movements3 = null;
    }
  });

  // 동작 3단계 변경
  $scope.$watch('vm.selectedMovement3', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.movement_id = newVal.id;
    }
  });

  // 사용자 정보수정 modal 이 ng-if 로 생성되어서 아래와 같이 jQuery file upload 를 생성해줌
  $scope.$watch('vm.showModal', function(newVal, oldVal) {
    if (newVal) {
      $timeout(function() {
        // 사진 이미지 업로드
        var fileUploadOptions = {
          forceIframeTransport: (vm.appContext.isMobileApp ? false : true),
          url: AppSettings.apiUrl.restRoot + 'user/upload_image',
          done: function (e, data) {
            var result;
            // iOS
            if (data.result && typeof data.result === 'string') {
              var obj = JSON.parse(data.result);
              $scope.$apply(function () {
                vm.joinData.image_url = obj.image_url;
              });
            }
            // PC, Android
            else if (data.result && data.result[0].body) {
              result = data.result[0].body.innerHTML;
              if (!isJSON(result)) {   // 구글 번역으로 인해 JSON 이외에 html tag 가 같이 온 경우
                if (result.match('div')) {
                  var temp = result.split('{'),
                    temp2 = temp[1].split('}');
                  result = '{' + temp2[0] + '}';
                }
              }
              $scope.$apply(function () {
                vm.joinData.image_url = (JSON.parse(result)).image_url;
              });
            }
      
          }
        };
        // Android, iOS
        if (!vm.appContext.isMobileApp) {
          fileUploadOptions.redirect = location.origin + '/#!/result';
        }
        // iOS
        if (vm.appContext.isIOS) {
          fileUploadOptions.add = function(e, data) {
            console.log('add', e, data);
            if (data.autoUpload || (data.autoUpload !== false &&
              $(this).fileupload('option', 'autoUpload'))) {
                data.process().done(function () {
                    data.submit();
                });
            }
          };
        }
        $('#upload_image').fileupload(fileUploadOptions);
      });
    }
  });

  // 팀 이미지 업로드
  var teamFileUploadOptions = {
    forceIframeTransport: (vm.appContext.isMobileApp ? false : true),
    url: AppSettings.apiUrl.restRoot + 'user/upload_image',
    done: function (e, data) {
      var result;
      // iOS
      if (data.result && typeof data.result === 'string') {
        var obj = JSON.parse(data.result);
        $scope.$apply(function () {
          vm.createData.image_url = obj.image_url;
          vm.uploadEmblemData.image_url = obj.image_url;
        });
      }
      // PC, Android
      else if (data.result && data.result[0].body) {
        result = data.result[0].body.innerHTML;
        if (!isJSON(result)) {   // 구글 번역으로 인해 JSON 이외에 html tag 가 같이 온 경우
          if (result.match('div')) {
            var temp = result.split('{'),
              temp2 = temp[1].split('}');
            result = '{' + temp2[0] + '}';
          }
        }
        $scope.$apply(function () {
          vm.createData.image_url = (JSON.parse(result)).image_url;
          vm.uploadEmblemData.image_url = (JSON.parse(result)).image_url;
        });
      }

    }
  };
  // Android, iOS
  if (!vm.appContext.isMobileApp) {
    teamFileUploadOptions.redirect = location.origin + '/#!/result';
  }
  // iOS
  if (vm.appContext.isIOS) {
    teamFileUploadOptions.add = function(e, data) {
      console.log('add', e, data);
      if (data.autoUpload || (data.autoUpload !== false &&
        $(this).fileupload('option', 'autoUpload'))) {
          data.process().done(function () {
              data.submit();
          });
      }
    };
  }
  $('#upload_team_image').fileupload(teamFileUploadOptions);  // 팀 생성
  $('#upload_team_image2').fileupload(teamFileUploadOptions);  // 팀엠블렘 수정



  $scope.imageChanged = function (element) {

    // alert('aaaa');
    // return;  
    $scope.isUploading = true;
    $scope.$apply(function (scope) {
      var file = element.files[0];
      var fd = new FormData();
      // fd.append('file', file);
      fd.append('upload', file);
      $http.post(AppSettings.apiUrl.restRoot + 'user/upload_image', fd, {
        // $http.post(AppSettings.apiUrl.restRoot + 'user/upload_image', fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      }).then(function (res) {
        $scope.isUploading = false;
        console.log(res.data);
        // $scope.data.images.push({ url: "/files/" + res.data });
      }, function (err) {
        $scope.isUploading = false;
        console.log("error", err)
      }).catch(function(err) {
        console.log(err);
      });
    });
  };



  $scope.uploadFiles = function () {
    var newdata = "";

    var filesSelected = document.getElementById("imageUploadfile").files;
    if (filesSelected.length > 0) {
      var fileToLoad = filesSelected[0];
      var fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        var newdata = fileLoadedEvent.target.result;
        // console.log(newdata);
      };
      fileReader.readAsDataURL(fileToLoad);
    }

    if (newdata != undefined) {
      console.log("newdata has value... now uploading....");
      // testAPIService.postUploadImage(newdata).success(function (response) {
      //   var imageurl = _TestBaseUrl + 'Images/' + response.filePath.split(/(\\|\/)/g).pop();
      //   $scope.testTypeImage_url = imageurl;
      // }).error(function (response) {
      //   alert(response.responseText);  // This alert is now coming
      // });

      /*

// service - Here formdata parameter valus is coming as empty.
 testAPIService.postUploadImage = function (formdata) {
        var request = {
            url: urlBase + 'UploadImage',
            method: 'POST',
            data: formdata,
            headers: {
                'Content-Type': undefined
            }

        }
        return $http(request);
    };

      */


      $http.post(AppSettings.apiUrl.restRoot + 'user/upload_image', newdata, {
        // $http.post(AppSettings.apiUrl.restRoot + 'user/upload_image', fd, {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      }).then(function (res) {
        $scope.isUploading = false;
        console.log(res.data);
        // $scope.data.images.push({ url: "/files/" + res.data });
      }, function (err) {
        $scope.isUploading = false;
        console.log("error", err)
      }).catch(function(err) {
        console.log(err);
      });



    } else {
      alert("undefined")
    }
  }




  // 팬으로 로그인한 경우 선수 추가
  vm.fanAddPlayers = function (addUsers) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '추가확인',
      content: '추가하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '추가',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 추가 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 선수를 users_ids 에 추가
              var users = res.data.users_ids.split(',');
              users = _.filter(users, function(item) {
                return !!item;
              });
              var newUsers = _.concat(users, addUsers);
              _.forEach(newUsers, function(item, i) {
                newUsers[i] = +item;
              });
              newUsers = _.uniq(newUsers);

              if (typeof addUsers === 'string' || typeof addUsers === 'number') {
                addUsers = [addUsers];
              }

              if (!addUsers || users.length + addUsers.length > newUsers.length) {
                toastr.error('중복된 선수입니다.');
                return;
              }

              var newUsersIds = newUsers.join(',');

              vm.joinData.users_ids = newUsersIds;

              vm.isEditMode = true;
              vm.saveUser();
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 추가 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 팬으로 로그인한 경우 선수 삭제
  vm.fanRemovePlayer = function (userId) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 삭제 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 선수를 users_ids 에서 제외
              var users = res.data.users_ids.split(',');
              _.forEach(users, function(item, i) {
                users[i] = +item;
              });
              var newUsers = _.difference(users, [+userId]),
                newUsersIds = newUsers.join(',');

              if (!newUsersIds) {
                newUsersIds = '""';
              }

              vm.joinData.users_ids = newUsersIds;

              vm.isEditMode = true;
              vm.saveUser(true);
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 삭제 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  vm.beforeFanAddTeam = function() {
    // 팀은 최대 1팀까지 추가할 수 있음
    if (vm.members.length > 0) {
      toastr.error('최대 한팀까지 추가하실 수 있습니다.');
    } else {
      vm.showSearchModal = !vm.showSearchModal;
      vm.searchModalMode = 'FanSearchTeam';
    }
  };

  // 팬으로 로그인한 경우 팀 추가
  vm.fanAddTeam = function (addTeam) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '추가확인',
      content: '추가하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '추가',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 추가 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 선수를 users_ids 에 추가
              var teams = res.data.teams_ids.split(',');
              teams = _.filter(teams, function(item) {
                return !!item;
              });
              var newTeams = _.concat(teams, addTeam);
              _.forEach(newTeams, function(item, i) {
                newTeams[i] = +item;
              });
              newTeams = _.uniq(newTeams);

              if (typeof addTeam === 'string' || typeof addTeam === 'number') {
                addTeam = [addTeam];
              }

              if (!addTeam || teams.length + addTeam.length > newTeams.length) {
                toastr.error('중복된 팀입니다.');
                return;
              }

              var newTeamsIds = newTeams.join(',');

              vm.joinData.teams_ids = newTeamsIds;






              vm.isEditMode = true;
              vm.saveUser();
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 추가 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 팬으로 로그인한 경우 팀 삭제
  vm.fanRemoveTeam = function (teamId) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 삭제 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 팀을 teams_ids 에서 제외
              var teams = res.data.teams_ids.split(',');
              _.forEach(teams, function(item, i) {
                teams[i] = +item;
              });
              var newTeams = _.difference(teams, [+teamId]),
                newTeamsIds = newTeams.join(',');

              vm.joinData.teams_ids = newTeamsIds ? newTeamsIds : '';

              vm.isEditMode = true;
              vm.saveUser(true, true);
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 삭제 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 팬으로 로그인한 경우 선수 검색, 팀 검색
  vm.modalSelectedPlayers = [];   // modal 에서 선택한 선수들
  vm.modalSelectedTeam = null;    // modal 에서 선택한 팀

  // 선수 선택 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.modalContinents = data.list;
  });

  // 선수 선택 -  대륙 변경
  $scope.$watch('vm.modalTeamContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries = res.data.list;
        vm.modalTeams1 = vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  국가 변경
  $scope.$watch('vm.modalTeamCountry', function (newVal, oldVal) {
    if (newVal) {
      country_id = newVal.id
      var data = {
        country_id: country_id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams1 = res.data.list;
          vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
        }).catch(function(err) {
          console.log(err);
        });
    }
  });

  // 선수 선택 -  팀 1단계 변경
  $scope.$watch('vm.modalTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams2 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams3 = vm.modalTeams4 = null;

      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  팀 2단계 변경
  $scope.$watch('vm.modalTeam2', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams3 = res.data.list;
        vm.modalTeams4 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  팀 3단계 변경
  $scope.$watch('vm.modalTeam3', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams4 = res.data.list;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  var selectedTeam = {};
  // 선수 선택 -  팀 4단계 변경
  $scope.$watch('vm.modalTeam4', function (newVal, oldVal) {
    if (newVal) {
      // vm.joinData.agency_team_id = newVal.id;
      // vm.joinData.agency_team_name = newVal.name;
      selectedTeam.id = newVal.id;
      selectedTeam.name = newVal.name;

      // 선수 검색
      var data = {
        all: 'Y',
        team_id: newVal.id
      };

      PlayerService.getPlayers(data)
        .then(function (res) {
          vm.modalPlayers = res.data.players;
        })
        .catch(function (error) {
          console.log('ERROR ', error)
        });
    }
  });

  // 팀 선택 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.modalContinents2 = data.list;
  });

  // 팀 선택 -  대륙 변경
  $scope.$watch('vm.modalTeamContinent2', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries2 = res.data.list;
        vm.modalTeams12 = vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  국가 변경
  $scope.$watch('vm.modalTeamCountry2', function (newVal, oldVal) {
    if (newVal) {
      country_id = newVal.id
      var data = {
        country_id: country_id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams12 = res.data.list;
          vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = null;
        }).catch(function(err) {
          console.log(err);
        });
    }
  });

  // 팀 선택 -  팀 1단계 변경
  $scope.$watch('vm.modalTeam12', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams22 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams32 = vm.modalTeams42 = null;

      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 2단계 변경
  $scope.$watch('vm.modalTeam22', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams32 = res.data.list;
        vm.modalTeams42 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 3단계 변경
  $scope.$watch('vm.modalTeam32', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams42 = res.data.list;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 4단계 변경
  $scope.$watch('vm.modalTeam42', function (newVal, oldVal) {
    if (newVal) {
      vm.modalSelectedTeam = newVal.id;
    }
  });

  // 선수 팀 선택 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.modalContinents3 = data.list;
  }).catch(function(err) {
    console.log(err);
  });

  // 선수 팀 선택 -  대륙 변경
  $scope.$watch('vm.modalTeamContinent3', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries3 = res.data.list;
        vm.modalTeams13 = vm.modalTeams23 = vm.modalTeams33 = vm.modalTeams43 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 팀 선택 -  국가 변경
  $scope.$watch('vm.modalTeamCountry3', function (newVal, oldVal) {
    if (newVal) {
      country_id = newVal.id
      var data = {
        country_id: country_id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams13 = res.data.list;
          vm.modalTeams23 = vm.modalTeams33 = vm.modalTeams43 = null;
        }).catch(function(err) {
          console.log(err);
        });
    }
  });

  // 선수 팀 선택 -  팀 1단계 변경
  $scope.$watch('vm.modalTeam13', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams23 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams33 = vm.modalTeams43 = null;

      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 팀 선택 -  팀 2단계 변경
  $scope.$watch('vm.modalTeam23', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams33 = res.data.list;
        vm.modalTeams43 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 팀 선택 -  팀 3단계 변경
  $scope.$watch('vm.modalTeam33', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams43 = res.data.list;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // modal 에서 선수가 팀 선택
  vm.savePlayerSelectedTeam = function () {
    if (vm.modalTeam43) {
      vm.joinData.team_id = vm.modalTeam43.id;
      vm.joinData.team_name = vm.modalTeam43.name;
    }
  };

  // modal 에서 선수 선택
  vm.addRemoveUsers = function (mode, $event, user) {
    // 선수
    if (mode === 'Player') {
      if ($event && $event.target.checked) {  // 추가
        vm.modalSelectedPlayers.push(user);
      } else {  // 삭제
        _.remove(vm.modalSelectedPlayers, {
          user_id: user.user_id
        });
      }
    }
  };

  // 선택한 선수 저장
  vm.saveFanSelectedUsers = function () {
    var users = _.map(vm.modalSelectedPlayers, 'user_id'),
      usersIds = users.join(',');

    vm.fanAddPlayers(usersIds);

    vm.modalSelectedPlayers = [];
  };

  // 선택한 팀 저장
  vm.saveFanSelectedTeam = function () {
    vm.fanAddTeam(vm.modalSelectedTeam);

    vm.modalSelectedTeam = null;
  };

  // 인증메일 발송
  vm.generateCode = function () {
    if (!vm.joinData.login_id) {
      toastr.error('이메일을 입력해주십시오');
      return;
    }

    UserService.generateCode({ email: vm.joinData.login_id }).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        toastr.success('인증메일을 발송중입니다. 잠시만 기다려주십시오');
        UserService.sendCodeMail({ email: vm.joinData.login_id }).then(function (res) {
          var data = res.data;
          if (data.result === 'SUC') {
            toastr.success('인증메일이 발송되었습니다. 메일에 있는 인증코드를 입력해주십시오');
          }
        }).catch(function(err) {
          console.log(err);
        });
      }
    }).catch(function(err) {
      console.log(err);
    });
  };




  // 팀생성 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.teamStadiumContinents = data.list;

    vm.teamStadiumContinent = vm.teamStadiumContinents[0];
  }).catch(function(err) {
    console.log(err);
  });

  // 팀생성 -  대륙 변경
  $scope.$watch('vm.teamStadiumContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.teamStadiumCountries = res.data.list;

        vm.teamStadiumCountry = vm.teamStadiumCountries[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀생성 -  국가 변경
  $scope.$watch('vm.teamStadiumCountry', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getStadiums({
        country_id: newVal.id
      }).then(function (res) {
        vm.parentStadiums = res.data.list;

        vm.stadiums = null;

        vm.parentStadium = vm.parentStadiums[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀생성 -  지역 변경
  $scope.$watch('vm.parentStadium', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getStadiums({
        country_id: vm.teamStadiumCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.stadiums = res.data.list;

        vm.stadium = vm.stadiums[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀생성 -  운동장 변경
  $scope.$watch('vm.stadium', function (newVal, oldVal) {
    if (newVal) {
      vm.createData.stadium_id = newVal.id;
    }
  });



  // 운동장 생성 데이터
  vm.createStadiumData = {
    login_id: vm.appContext.user.login_id,
    parent_id: null,
    country_id: null,
    name: null
  };

  // 운동장 생성 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.stadiumContinents = data.list;

    vm.stadiumContinent = vm.stadiumContinents[0];
  }).catch(function(err) {
    console.log(err);
  });

  // 운동장 생성 -  대륙 변경
  $scope.$watch('vm.stadiumContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.stadiumCountries = res.data.list;

        vm.stadiumCountry = vm.stadiumCountries[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 운동장 생성 -  국가 변경
  $scope.$watch('vm.stadiumCountry', function (newVal, oldVal) {
    if (newVal) {
      vm.createStadiumData.country_id = newVal.id;

      PlanService.getStadiums({
        country_id: newVal.id
      }).then(function (res) {
        vm.stadiumCities = res.data.list;
        vm.stadiumStadiums = null;

        vm.stadiumCity = vm.stadiumCities[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 운동장 생성 -  지역 변경
  $scope.$watch('vm.stadiumCity', function (newVal, oldVal) {
    if (newVal) {
      PlanService.getStadiums({
        country_id: vm.stadiumCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.stadiumStadiums = res.data.list;

        vm.stadiumStadium = vm.stadiumStadiums[0];
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 운동장 생성 - 지역 생성
  vm.createStadiumCity = function () {
    if (!vm.createStadiumData.city) {
      toastr.error('지역명을 입력하십시오');
      return;
    }

    vm.createStadiumData.parent_id = 0;
    vm.createStadiumData.name = vm.createStadiumData.city;

    UserService.addStadium(vm.createStadiumData).then(function (res) {
      toastr.success('지역이 생성되었습니다.');

      PlanService.getStadiums({
        country_id: vm.createStadiumData.country_id
      }).then(function (res) {
        vm.stadiumCities = res.data.list;

        vm.stadiumCity = vm.stadiumCities[0];
      }).catch(function(err) {
        console.log(err);
      });

      vm.createStadiumData.city = null;
      vm.createStadiumData.parent_id = null;
      vm.createStadiumData.name = null;
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 운동장 생성
  vm.createStadium = function () {
    if (!vm.createStadiumData.stadium) {
      toastr.error('운동장명을 입력하십시오');
      return;
    }

    vm.createStadiumData.parent_id = vm.stadiumCity.id;
    vm.createStadiumData.name = vm.createStadiumData.stadium;

    UserService.addStadium(vm.createStadiumData).then(function (res) {
      toastr.success('운동장이 생성되었습니다.');

      PlanService.getStadiums({
        parent_id: vm.createStadiumData.parent_id
      }).then(function (res) {
        vm.stadiumStadiums = res.data.list;

        vm.stadiumStadium = vm.stadiumStadiums[0];
      }).catch(function(err) {
        console.log(err);
      });

      vm.createStadiumData.stadium = null;
      vm.createStadiumData.parent_id = null;
      vm.createStadiumData.name = null;
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 운동장 삭제
  vm.removeStadium = function(type, name, id) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '"' + name + '" 을(를) 삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            UserService.removeStadium({
              login_id: vm.appContext.user.login_id,
              id: id
            }).then(function(res) {
              toastr.success('삭제 되었습니다.');

              // 운동장 삭제
              if (type === 'stadium') {
                vm.stadiumStadiums = _.reject(vm.stadiumStadiums, {
                  id: id
                });
                vm.stadiumStadium = vm.stadiumStadiums[0];
              }
              // 지역 삭제
              else if (type === 'city') {
                vm.stadiumCities = _.reject(vm.stadiumCities, {
                  id: id
                });
                vm.stadiumCity = vm.stadiumCities[0];
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };



  // 선수 카드 클릭시 선수관리 선수 상세정보 화면으로 이동
  vm.viewPlayerDetail = function(userId, loginId, flag, teamId, name) {
    if ($stateParams.target === 'MyTeamPlayer' || $stateParams.target === 'Scout') {
      // 팬인 경우
      if (vm.appContext.role2 === 'fan') {
        if (userId && teamId && name) {
          $state.go('Service.playerDetail', { user_id: userId, team_id: vm.appContext.info.team_id, fan_user_id: userId, fan_user_team_id: teamId, fan_login_id: loginId, fan_user_name: name });
        }
        // else if (userId) {
        //   $state.go('Service.planner', { type_code: 'team', fan_user_id: userId });
        // }
      } else {
        $state.go('Service.playerDetail', { type_code: 'team', type_name: '팀', user_id: userId });
      }
    }
  };

  // 팬으로 로그인시 팀선택
  vm.viewTeamDetail = function(teamId) {
    console.log('team id', teamId);
    $state.go('Service.planner', {type_code:'team',type_name:'팀',team_id:teamId,fan_team_id:teamId,fan_user_id:null,fan_login_id:null});
  };

  // 구단주나 단장으로 로그인시 팀선택
  vm.viewOwnerTeamDetail = function(teamId, loginId, uuid) {
    console.log('team id', teamId, loginId, uuid);
    $state.go('Service.planner', {type_code:'team',type_name:'팀',team_id:teamId,manager_admin_team_id:teamId,owner_login_id:loginId,owner_uuid:uuid});
  };

  if ($stateParams.payed === 'Y') {
    vm.appContext.info.payed = 'Y';
    vm.appContext.user.payed = 'Y';
  }

  var payInfo = AppSettings.payInfo;

  // 회원 구분에 따라 vm.payInfoItems 생성
  if ($stateParams.target === 'MyTeamPlayer' || $stateParams.target === 'Scout') {
    vm.payInfoItems = payInfo.player;
    vm.payInfoType = 'player';
  } else if (vm.appContext.role2 === 'team_staff' || vm.appContext.role2 === 'coaching_staff' || $stateParams.target === 'MyTeam' || $stateParams.target === 'TeamStep' || $stateParams.target === 'CoachingStep') {
    vm.payInfoItems = payInfo.team;
    vm.payInfoType = 'team';
  } else if (vm.appContext.role2 === 'player') {
    vm.payInfoItems = payInfo.player;
    vm.payInfoType = 'player';
  } else if (vm.appContext.role2 === 'fan' || $stateParams.target === 'TeamSponsors' || $stateParams.target === 'TeamSponsors2') {
    vm.payInfoItems = payInfo.fan;
    vm.payInfoType = 'fan';
  } else {
    // 전체 관리자
    vm.payInfoItems = payInfo.team.concat(payInfo.player).concat(payInfo.fan);
    vm.payInfoType = 'all';
  }
  // bank - 무통장결제, trans - 실시간 계좌이체, card - 카드, phone - 휴대폰 결제 paypal - 페이팔
  if (vm.appContext.isIOS || (vm.appContext.role2 !== 'sa21c' && vm.appContext.role2 !== 'coaching_staff' && vm.appContext.role2 !== 'team_staff')) {
    vm.payType = 'trans'; // iOS 에서는 무통장결제 표시하지 않음
  } else {
    vm.payType = 'bank';
  }
  vm.payQuantity = 1;
  vm.payPeriod = 1;
  vm.payDeviceQuantity = 1;
  vm.payBusinessQuantity = 0;
  vm.limitedPromotion = 0;
  vm.promotionApply = false;

  // 프로모션 코드를 적용하지 않는 것으로 수정
  vm.promotionApply = true;

  // 본사 직접결제 사용여부
  vm.directPay = true;

  /*
  // 프로모션 코드 적용
  $scope.$watch('vm.promotionCode', function(newVal, oldVal) {
    if (newVal === AppSettings.promotionCode) {
      vm.promotionApply = true;
    } else {
      vm.promotionApply = false;
    }
  });
  */

  // 결제방식 변경
  $scope.$watch('vm.payType', function(newVal, oldVal) {
    vm.selectedPayInfo = _.find(vm.payInfoItems, function(item) {
      return item.productName === 'TS 7' || item.productName === 'PS 7' || item.productName === 'FS 7';
    });
    
    vm.payPeriod = vm.selectedPayInfo.quantity;
  });

  // 한정 프로모션 계산
  $scope.$watch('vm.selectedPayInfo', function(newVal, oldVal) {
    if (newVal && newVal.unitPrice > 5000000) {
      $timeout(function() {
        vm.limitedPromotion = newVal.unitPrice - 5000000;
      }, 100);  // vm.selectedPayInfo 가 변경되는 순간 vm.limitedPromotion 이 0 이 되므로 약간의 시간뒤에 변경
    }

    // 본사직접결제는 TS 7, PS 7, FS 7 이 가능하도록 수정
    if (vm.selectedPayInfo.productName === 'TS 7' || vm.selectedPayInfo.productName === 'PS 7' || vm.selectedPayInfo.productName === 'FS 7') {
      vm.directPay = true;
    } else {
      vm.directPay = false;
    }
  });
  $scope.$watch('vm.payPeriod', function(newVal, oldVal) {
    if (newVal > 1) {
      if (vm.selectedPayInfo.unitPrice > 5000000) {
        vm.limitedPromotion = +vm.payPeriod * +vm.selectedPayInfo.unitPrice - 5000000;
      } else {
        vm.limitedPromotion = (newVal - 1) * +vm.selectedPayInfo.unitPrice;
      }
    } else {
      if (vm.selectedPayInfo.unitPrice > 5000000) {
        vm.limitedPromotion = +vm.selectedPayInfo.unitPrice - 5000000;
      } else {
        vm.limitedPromotion = 0;
      }
    }
  });

  // 본사 직접 결제
  vm.bankPay = function() {
    var date = new Date(),
      year = date.getFullYear(),
      month = date.getMonth() + 1,
      date = date.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (date < 10) {
      date = '0' + date;
    }

    // 결제 UID
    var orderUid = 'ORD' + year + month + date + '-' + parseInt(Math.random() * 9999999, 10); // 예) ORD20180131-0000101

    // 결제 정보 저장
    var payData = {
      login_id: 'Fmstar@naver.com',
      uid: orderUid,
      product_name: vm.selectedPayInfo.productName,
      amount: vm.payPeriod,
      price: vm.selectedPayInfo.promotion.quantity ? 0 : +vm.selectedPayInfo.unitPrice,   // 본사 직접 결제
      pay_time: timeToDate(+new Date())
    };
    // 결제 받는 사용자(팀) 아이디
    if (vm.rcv_user_id && vm.rcv_user_id != vm.appContext.user.user_id) {
      payData.rcv_user_id = vm.rcv_user_id;
    }
    
    UserService.pay(payData).then(function(res) {
      // 결제 정보 저장 성공
      if (res.data.result === 'SUC') {
        vm.appContext.info.payed = 'Y';
        vm.appContext.user.payed = 'Y';

        //toastr.success('결제되었습니다. 담당자에게 문의하세요. 담당자가 승인후 사용하실 수 있습니다.');
        vm.paymentInfoModal = false;

        // 페이지 정보 새로 로드
        $stateParams.payed = 'Y';
        $state.go('Service.member', $stateParams, { reload: true });
      }
    }).catch(function(err) {
      console.log(err);
    });
  };

  // 아임포트 결제 모듈 초기화
  var IMP = window.IMP;
  var iamportUserCode = 'imp05378196';
  IMP.init(iamportUserCode);

  // 결제창 띄우기
  vm.openPaymentPopup = function() {
    if (vm.selectedPayInfo.productName === 'SGS TOKEN') {
      toastr.success('서비스 준비중');
      return;
    }

    var date = new Date(),
      year = date.getFullYear(),
      month = date.getMonth() + 1,
      date = date.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (date < 10) {
      date = '0' + date;
    }

    // 결제 UID
    var orderUid = 'ORD' + year + month + date + '-' + parseInt(Math.random() * 9999999, 10); // 예) ORD20180131-0000101

    // 결제할 사용자 정보 불러온 후 결제창 띄우기
    var payUserId = vm.appContext.user.user_id;
    
    UserService.info({
      'user_id': payUserId
    }).then(function (res) {
      console.log(res.data);

      // 주소에서 우편번호 분리
      var temp = res.data.address.split(') '),
        temp2 = temp[0].split('('),
        postcode = temp2[1],
        addr = temp[1],
        amount;

      if (vm.payType === 'paypal') {
        amount = ((vm.selectedPayInfo.productName === 'TS 700' ? +vm.payPeriod : 1) * +vm.selectedPayInfo.unitPriceUSD - +vm.selectedPayInfo.promotion.priceUSD) * 1.1;

        if (vm.selectedPayInfo.productName === 'TS 700' || vm.selectedPayInfo.productName === 'TS 70' || vm.selectedPayInfo.productName === 'TS 7') {
          amount = (+vm.payPeriod * +vm.selectedPayInfo.unitPriceUSD - (vm.promotionApply ? +vm.payPeriod * +vm.selectedPayInfo.promotion.priceUSD : 0) + (vm.selectedPayInfo.deviceUnitPriceUSD ? +vm.payDeviceQuantity * +vm.selectedPayInfo.deviceUnitPriceUSD : 0) + (vm.selectedPayInfo.businessUnitPriceUSD ? +vm.payBusinessQuantity * +vm.selectedPayInfo.businessUnitPriceUSD : 0)) * 1.1;
        } else {
          amount = (+vm.payPeriod * +vm.selectedPayInfo.unitPriceUSD - (vm.promotionApply ? +vm.payPeriod * +vm.selectedPayInfo.promotion.priceUSD : 0) + (vm.selectedPayInfo.deviceUnitPriceUSD ? +vm.payDeviceQuantity * +vm.selectedPayInfo.deviceUnitPriceUSD : 0) + (vm.selectedPayInfo.businessUnitPriceUSD ? +vm.payBusinessQuantity * +vm.selectedPayInfo.businessUnitPriceUSD : 0)) * 1.1;  
        }
      } else {
        amount = parseInt(((vm.selectedPayInfo.productName === 'TS 700' ? +vm.payPeriod : 1) * +vm.selectedPayInfo.unitPrice - +vm.selectedPayInfo.promotion.price) * 1.1, 10); // 가격 - 27500.000000000004 와 같이 계산되는 경우 결제창이 뜨지 않아 parseInt 처리함

        if (vm.selectedPayInfo.productName === 'TS 700' || vm.selectedPayInfo.productName === 'TS 70' || vm.selectedPayInfo.productName === 'TS 7') {
          amount = parseInt((+vm.payPeriod * +vm.selectedPayInfo.unitPrice - (vm.promotionApply ? +vm.payPeriod * +vm.selectedPayInfo.promotion.price : 0) + (vm.selectedPayInfo.deviceUnitPrice ? +vm.payDeviceQuantity * +vm.selectedPayInfo.deviceUnitPrice : 0) + (vm.selectedPayInfo.businessUnitPrice ? +vm.payBusinessQuantity * +vm.selectedPayInfo.businessUnitPrice : 0)) * 1.1, 10);
        } else {
          amount = parseInt((+vm.payPeriod * +vm.selectedPayInfo.unitPrice - (vm.promotionApply ? +vm.payPeriod * +vm.selectedPayInfo.promotion.price : 0) + (vm.selectedPayInfo.deviceUnitPrice ? +vm.payDeviceQuantity * +vm.selectedPayInfo.deviceUnitPrice : 0) + (vm.selectedPayInfo.businessUnitPrice ? +vm.payBusinessQuantity * +vm.selectedPayInfo.businessUnitPrice : 0)) * 1.1, 10);  
        }
      }


      // mobile 결제에서 필요한 함수 : ng-cordova-iamport.js - https://github.com/iamport/iamport-ionic-inicis
      function parseQuery(query) {
        var obj = {},
            arr = query.split('&');
        for (var i = 0; i < arr.length; i++) {
            var pair = arr[i].split('=');

            obj[ decodeURIComponent(pair[0]) ] = decodeURIComponent(pair[1]);
        }

        return obj;
      }

      // mobile 결제에서 필요한 함수 : ng-cordova-iamport.js - https://github.com/iamport/iamport-ionic-inicis
      function iamportPayment(user_code, param) {
        var deferred = $q.defer();

        if( cordova.InAppBrowser ) {
          var payment_url = 'iamport-checkout.html?user-code=' + user_code,
              m_redirect_url = 'http://localhost/iamport';

          param.m_redirect_url = m_redirect_url;//강제로 변환

          var inAppBrowserRef = cordova.InAppBrowser.open(payment_url, '_blank', 'hardwareback=no'),
              paymentProgress = false;

          var startCallback = function(event) {
            if( (event.url).indexOf(m_redirect_url) === 0 ) { //결제 끝.
              var query = (event.url).substring( m_redirect_url.length + 1 ) // m_redirect_url+? 뒤부터 자름
              var data = parseQuery(query); //query data

              deferred.resolve(data);
              finish();
            }
          };

          var stopCallback = function(event) {
            if ( !paymentProgress && (event.url).indexOf(payment_url) > -1 ) {
              paymentProgress = true;

              var inlineCallback = "function(rsp) {if(rsp.success) {location.href = '" + m_redirect_url + "?imp_success=true&imp_uid='+rsp.imp_uid+'&merchant_uid='+rsp.merchant_uid;} else {location.href = '" + m_redirect_url + "?imp_success=false&imp_uid='+rsp.imp_uid+'&merchant_uid='+rsp.merchant_uid+'&error_msg='+rsp.error_msg;}}",
                  iamport_script = "IMP.request_pay(" + JSON.stringify(param) + "," + inlineCallback + ")";

              inAppBrowserRef.executeScript({
                code : iamport_script
              });
            }
          };

          var exitCallback = function(event) {
            deferred.reject("사용자가 결제를 취소하였습니다.");
          };

          var finish = function() {
            inAppBrowserRef.removeEventListener('loadstart', startCallback);
            inAppBrowserRef.removeEventListener('loadstop', stopCallback);
            inAppBrowserRef.removeEventListener('exit', exitCallback);
            setTimeout(function() {
              inAppBrowserRef.close();
            }, 10);
          }

          inAppBrowserRef.addEventListener('loadstart', startCallback);
          inAppBrowserRef.addEventListener('loadstop', stopCallback);
          inAppBrowserRef.addEventListener('exit', exitCallback);

          //for KakaoPay
          if ( param.app_scheme ) {
            var oldHandleOpenUrl = window.handleOpenURL;

            window.handleOpenURL = function(url) {
              if ( url == (param.app_scheme+'://process') ) {
                inAppBrowserRef.executeScript({
                  code : "IMP.communicate({result:'process'})"
                });
              } else if ( url == (param.app_scheme+'://cancel') ) {
                inAppBrowserRef.executeScript({
                  code : "IMP.communicate({result:'cancel'})"
                });
              } else {
                oldHandleOpenUrl(url);
              }
            }
          }

          inAppBrowserRef.show();

        } else {
          deferred.reject("InAppBrowser plugin을 필요로 합니다. InAppBrowser plugin를 찾을 수 없습니다.");
        }

        return deferred.promise;
      }



      // mobile 결제에서 필요한 함수 : ng-cordova-iamport.js - https://github.com/iamport/iamport-ionic-inicis
      // 모바일
      if (vm.appContext.isMobile) {
        iamportPayment(iamportUserCode, { // param
          pg: (vm.payType === 'paypal' ? vm.payType : "html5_inicis"),
          pay_method: vm.payType,
          merchant_uid: orderUid,  // 결제에 대한 uid
          name: vm.selectedPayInfo.productName, // 상품명
          amount: amount,
          buyer_email: res.data.login_id,
          buyer_name: res.data.name,
          buyer_tel: res.data.min1 + '-' + res.data.min2 + '-' + res.data.min3,
          buyer_addr: addr,
          buyer_postcode: postcode,
          display: {
            card_quota: [2, 3]
          },
          app_scheme: 'sgsmanagerapp',
          m_redirect_url: location.href
        }).then(function(result) {
          toastr.success('결제에 성공하였습니다.');

          // 결제 정보 저장
          var payData = {
            login_id: vm.appContext.user.login_id,
            uid: orderUid,
            product_name: vm.selectedPayInfo.productName,
            amount: vm.payPeriod,
            price: +vm.selectedPayInfo.unitPrice,
            pay_time: timeToDate(+new Date())
          };
          // 결제 받는 사용자(팀) 아이디
          if (vm.rcv_user_id && vm.rcv_user_id != vm.appContext.user.user_id) {
            payData.rcv_user_id = vm.rcv_user_id;
          }
          UserService.pay(payData).then(function(res) {
            // 결제 정보 저장 성공
            if (res.data.result === 'SUC') {
              vm.appContext.info.payed = 'Y';
              vm.appContext.user.payed = 'Y';

              // 페이지 정보 새로 로드
              $stateParams.payed = 'Y';
              $state.go('Service.member', $stateParams, { reload: true });
            }
          }).catch(function(err) {
            console.log(err);
          });
        }).catch(function(err) {
          console.log(err);
        });
      }
      // web
      else {
        // IMP.request_pay(param, callback) 호출
        IMP.request_pay({ // param
          pg: (vm.payType === 'paypal' ? vm.payType : "html5_inicis"),
          pay_method: vm.payType,
          merchant_uid: orderUid,  // 결제에 대한 uid
          name: vm.selectedPayInfo.productName, // 상품명
          amount: amount,
          buyer_email: res.data.login_id,
          buyer_name: res.data.name,
          buyer_tel: res.data.min1 + '-' + res.data.min2 + '-' + res.data.min3,
          buyer_addr: addr,
          buyer_postcode: postcode,
          display: {
            card_quota: [2, 3]
          },
          m_redirect_url: location.href
        }, function (rsp) { // callback
          console.log(rsp);

          // 페이지 정보 새로 로드
          $state.go('Service.member', $stateParams, { reload: true });

          if (rsp.success) {
              // 결제 성공 시 로직,
              console.log(rsp);

              toastr.success('결제에 성공하였습니다.');

              // 결제 정보 저장
              var payData = {
                login_id: vm.appContext.user.login_id,
                uid: orderUid,
                product_name: vm.selectedPayInfo.productName,
                amount: vm.payPeriod,
                price: +vm.selectedPayInfo.unitPrice,
                pay_time: timeToDate(+new Date())
              };
              // 결제 받는 사용자(팀) 아이디
              if (vm.rcv_user_id && vm.rcv_user_id != vm.appContext.user.user_id) {
                payData.rcv_user_id = vm.rcv_user_id;
              }
              UserService.pay(payData).then(function(res) {
                // 결제 정보 저장 성공
                if (res.data.result === 'SUC') {
                  vm.appContext.info.payed = 'Y';
                  vm.appContext.user.payed = 'Y';
                  
                  // 페이지 정보 새로 로드
                  $stateParams.payed = 'Y';
                  $state.go('Service.member', $stateParams, { reload: true });
                }
              }).catch(function(err) {
                console.log(err);
              });
          } else {
              // 결제 실패 시 로직,
          }
        });
      }
    }).catch(function(err) {
      console.log(err);
    });
  };


  // 결제 이력 조회
  if ($stateParams.target === 'MyInfo') {
    var payHistoryData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid
    };
    UserService.paymentHistory(payHistoryData).then(function(res) {
      vm.paymentHistory = res.data.list && res.data.list.reverse();
  
      _.forEach(vm.paymentHistory, function(item) {
        item.remain = parseInt((+new Date(item.expire_time) - +new Date() + 86400 * 1000) / (86400 * 1000), 10);
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 현재 사용자가 국가 대표팀 소속 팀 관계자 / 감독인지 여부 - 추후 수정되어야 함
  if (
    ($stateParams.manager_admin_team_id && vm.appContext.my_team && vm.appContext.my_team.team_name === 'National Team') ||
    (vm.appContext.info.team_name === 'National Team' && (vm.appContext.user.user_type_id === '4' || vm.appContext.user.user_type_id === '10' || vm.appContext.user.user_type_id === '12' || vm.appContext.user.user_type_id === '22' ))
  ) {
    vm.appContext.user.canPick = true;
    vm.appContext.info.canPick = true;
  }


  // [1] 선수로 로그인한 경우
  //      1. 본인정보 메뉴
  //          => 내가 받은 이적요청 목록 확인
  //          => 내가 받은 발탁요청 목록 확인
  //          => 요청 목록을 확인하고 다른 어떤 기능이 있는 것은 아님
  // [2] 팀매니저, 감독으로 로그인한 경우
  //      (1) 일반팀 매니저, 감독인 경우
  //          1. 선수구성 메뉴
  //              => 우리팀 선수 중에 타 팀으로부터 이적, 발탁 요청을 했던 선수들이 있으면
  //                  이적요청 동의, 이적요청 거절, 발탁요청 동의, 발탁요청 거절 버튼이 보임
  //                  요청을 받지 않은 선수에게는 이적, 발탁 관련 버튼이 보이지 않음
  //              => 이적요청에 동의하면 해당 선수의 소속팀이 요청했던 팀으로 변경됨
  //              => 이적요청을 거절하면 이적요청 동의, 이적요청 거절 버튼이 없어짐
  //              => 발탁요청에 동의하면 해당 선수의 소속팀에 요청했던 대표팀이 추가됨
  //              => 발탁요청을 거절하면 발탁요청 동의, 발탁요청 거절 버튼이 없어짐
  //          2. 영입대상 메뉴
  //              => 이적요청 했던 선수 목록이 보임
  //              => 이적요청 취소 버튼이 있어서 이적 요청을 취소할 수 있음
  //                  이적요청을 취소하면 요청 받은팀 선수구성 메뉴에서 보이던 이적요청 동의, 이적요청 거절 버튼도 없어짐
  //              => 영입대상 메뉴에 있던 선수는 이적요청을 받은팀이 이적요청에 동의하면 선수구성 메뉴로 이동됨
  //              => 영입대상 메뉴에 있던 선수는 이적요청을 받은팀이 이적요청에 거절하면 영입대상 목록에서 없어짐
  //          3. 설정 및 생성 메뉴 (상대팀 선수 목록 보는 메뉴)
  //              => 각 선수에게 이적 버튼 보임
  //              => 이적 버튼을 클릭하여 이적 요청을 할 수 있음
  //              => 이적요청이 완료되면 영입대상 메뉴로 이동하고 영입대상 메뉴에 이적요청 했던 선수가 목록에 나타남
  //      (2) 국가대표팀 매니저, 감독인 경우
  //          1. 선수구성 메뉴
  //              => 현재 대표팀 선수 목록이 보임. 이적, 발탁 관련 버튼 등은 없음
  //          2. 영입대상 메뉴
  //              => 발탁요청 했던 선수 목록이 보임
  //              => 발탁요청 취소 버튼이 있어서 발탁 요청을 취소할 수 있음
  //                  발탁요청을 취소하면 요청 받은팀 선수구성 메뉴에서 보이던 발탁요청 동의, 발탁요청 거절 버튼도 없어짐
  //              => 영입대상 메뉴에 있던 선수는 발탁요청을 받은팀이 발탁요청에 동의하면 선수구성 메뉴로 이동됨
  //              => 영입대상 메뉴에 있던 선수는 발탁요청을 받은팀이 발탁요청에 거절하면 영입대상 목록에서 없어짐
  //          3. 설정 및 생성 메뉴 (상대팀 선수 목록 보는 메뉴)
  //              => 각 선수에게 발탁 버튼 보임
  //              => 발탁 버튼을 클릭하여 발탁 요청을 할 수 있음
  //              => 발탁요청이 완료되면 영입대상 메뉴로 이동하고 영입대상 메뉴에 발탁요청 했던 선수가 목록에 나타남

  // 우리팀 선수구성 메뉴에서는
  // => 이적 동의/거절 버튼
  // => 발탁 동의/거절 버튼
  // 상대팀 선수목록 메뉴에서는
  // => 이적 버튼
  // => 발탁 버튼 (로그인한 내가 국가대표팀 매니저, 감독인 경우)
  // 선수 본인정보 메뉴에서는
  // => 이적 요청 목록
  // => 발탁 요청 목록
  // 영입 대상 목록에서는
  // => 이적 요청 취소 버튼
  // => 발탁 요청 취소 버튼

  // 이적/발탁 요청
  vm.require = function(targetId, mode) {   // mode: T - 이적, P - 발탁
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: (mode === 'T' ? '이적' : '발탁') + ' 요청',
      content: '선택하신 선수의 ' + (mode === 'T' ? '이적' : '발탁') + '을 요청하시겠습니까? <input type="password" ng-model="vm.reqPasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '요청',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var requireData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              mode: mode,
              target_id: targetId,
              passwd: vm.reqPasswd
            };

            UserService.require(requireData).then(function(res) {
              if (res.data.result == 'ALREADY') {
                toastr.error('이미 요청 중입니다.');
              } else if (res.data.result == 'PW_MISS') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              } else if (res.data.result == 'SUC') {
                toastr.success((mode === 'T' ? '이적' : '발탁') + ' 요청에 성공하였습니다.');
                var params = angular.copy($stateParams);
                params.target = 'Scout';
                $state.go('Service.member', params, { reload: true });
              } else {
                toastr.error(res.data.result);
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 이적/발탁 요청 취소
  vm.cancelReq = function(id) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: (vm.appContext.user.canPick ? '발탁' : '이적') + ' 요청 취소',
      content: '선택하신 선수의 ' + (vm.appContext.user.canPick ? '발탁' : '이적') + ' 요청을 취소하시겠습니까? <input type="password" ng-model="vm.cancelReqPasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: '요청 취소',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var cancelReqData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id,
              passwd: vm.cancelReqPasswd
            };

            UserService.cancelReq(cancelReqData).then(function(res) {
              if (res.data.result == 'ALREADY') {
                toastr.error('이미 요청 중입니다.');
              } else if (res.data.result === 'PW_MISS') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              } else if (res.data.result === 'SUC') {
                toastr.success((vm.appContext.user.canPick ? '발탁' : '이적') + '요청이 취소되었습니다.');

                // 페이지 정보 새로 로드
                $state.go('Service.member', $stateParams, { reload: true });
              } else {
                toastr.error(res.data.result);
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 이적/발탁 요청 동의
  vm.agreeReq = function(mode, id) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: (mode === 'P' ? '발탁' : '이적') + ' 요청 동의',
      content: '선택하신 선수의 ' + (mode === 'P' ? '발탁' : '이적') + ' 요청에 동의하시겠습니까? <input type="password" ng-model="vm.agreeReqPasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: (mode === 'P' ? '발탁' : '이적') + '요청 동의',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var agreeReqData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id,
              passwd: vm.agreeReqPasswd
            };

            UserService.agreeReq(agreeReqData).then(function(res) {
              if (res.data.result == 'ALREADY') {
                toastr.error('이미 요청 중입니다.');
              } else if (res.data.result === 'PW_MISS') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              } else if (res.data.result === 'SUC') {
                toastr.success((mode === 'P' ? '발탁' : '이적') + '요청을 동의하였습니다.');

                // 페이지 정보 새로 로드
                $state.go('Service.member', $stateParams, { reload: true });
              } else {
                toastr.error(res.data.result);
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 이적/발탁 요청 거절
  vm.rejectReq = function(mode, id) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: (mode === 'P' ? '발탁' : '이적') + ' 요청 거절',
      content: '선택하신 선수의 ' + (mode === 'P' ? '발탁' : '이적') + ' 요청을 거절하시겠습니까? <input type="password" ng-model="vm.rejectReqPasswd" placeholder="비밀번호를 입력하세요">',
      scope: $scope,
      buttons: {
        confirm: {
          text: (mode === 'P' ? '발탁' : '이적') + '요청 거절',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var rejectReqData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id,
              passwd: vm.rejectReqPasswd
            };

            UserService.rejectReq(rejectReqData).then(function(res) {
              if (res.data.result == 'ALREADY') {
                toastr.error('이미 요청 중입니다.');
              } else if (res.data.result === 'PW_MISS') {
                toastr.error('비밀번호가 일치하지 않습니다.');
              } else if (res.data.result === 'SUC') {
                toastr.success((mode === 'P' ? '발탁' : '이적') + '요청을 거절하였습니다.');

                // 페이지 정보 새로 로드
                $state.go('Service.member', $stateParams, { reload: true });
              } else {
                toastr.error(res.data.result);
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 구단주나 단장에게 팀을 할당
  vm.adminSetTeam = function(userId, teamId) {
    // userId = 2445;    // 테스트 구단주
    // teamId = 27104;   // 10부리그 테스트팀

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '팀 지정',
      content: '선택하신 팀을 지정하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '팀 지정',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var setTeamData = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              user_id: userId,
              team_id: teamId
            };

            AdminService.setTeam(setTeamData).then(function(res) {
              if (res.data.result === 'ALREADY') {
                toastr.error('이미 등록된 팀입니다.');
              } else if (res.data.result === 'SUC') {
                toastr.success('팀이 등록되었습니다.');
              }
            }).catch(function(err) {
              console.log(err);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  if ($stateParams.target === 'MyInfo' && $stateParams.team_id == 27104) {
    var myTeamsData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid
    };
    
    // 구단주, 단장이 보유한 팀 목록
    UserService.myTeams(myTeamsData).then(function(res) {
      _.forEach(res.data.list, function(item) {
        UserService.login({
          login_id: item.login_id,
          passwd: item.passwd
        }).then(function (res) {
          console.log(item.team_id, item.team_name, res.data.login_id, res.data.user_id, res.data.uuid);
        }).catch(function(err) {
          console.log(err);
        })
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  vm.saveOwnerSelectedTeam = function() {
    vm.adminSetTeam(vm.selectedOwnerId, vm.modalSelectedTeam);

    vm.modalSelectedTeam = null;
  }

  // TS 7, PS 7 프로팀, 국가대표팀일 경우 본사직접결제 - 무료결제 가능하지 않도록
  // if ($stateParams.team2_id && ($stateParams.team2_id >= 92 && $stateParams.team2_id <= 96)) {
  //   vm.notFree = true;
  // } else {
  //   vm.notFree = false;
  // }

  vm.trustAsHtml = function(value) {
    return $sce.trustAsHtml(value);
  };

  // view 가 load 된 이후에 실행
  $scope.$on('$viewContentLoaded', function () {
    if ($stateParams.popup) {
      $timeout(function() {
        $('#payment-btn').trigger('click');
      }, 1000);
    }
  });

  /*
  // view 가 load 된 이후에 실행
  $scope.$on('$viewContentLoaded', function () {
    // bluetooth start
    vm.myDevices = [];
    vm.deviceMyListData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
    };
    document.addEventListener("deviceready", function() {
      ble.isEnabled(
        function(){
          // Bluetooth is enabled
        },
        function(){
          // Bluetooth not yet enabled so we try to enable it
          ble.enable(
            function(){
              // bluetooth now enabled
            },
            function(err){
              alert('Cannot enable bluetooth');
            }
          );
        }
      );

      var devices = [];
      vm.devices = [];  // 장비 목록

      vm.deviceScan = function(){

        ble.startScan(
          [],
          function(device){
            if(!device.name || device.name !== 'SGS_EPTS'){
              return;
            }

            DeviceService.myList(vm.deviceMyListData).then(function (res) {
              vm.myDevices = res.data.devices;
              vm.myDevices = _.uniqBy(vm.myDevices, 'token');

              var existingDevice = _.find(vm.myDevices, {
                token: device.id
              });

              // 등록된 장비 목록을 확인하여 이미 등록된 장비는 연결가능한 디바이스 목록에 표시하지 않음
              if (!existingDevice) {
                devices.push(device);
              }
            }).catch(function(err) {
              console.log(err);
            });
          },
          function(err){
            alert('디바이스 스캔에 실패하였습니다. 다시 시도해주십시오');
          }
        );

        setTimeout(
            ble.stopScan,
            1500,
            function(){
              $scope.$apply(function(){
                vm.devices = _.uniqBy(devices, 'id');
              });
            },
            function(){
              // Stopping scan failed
            }
        );

      };

      vm.deviceConnect = function(device_id){
        ble.connect(
          device_id,
          function(res){
            alert(device_id);
          },
          function(err){
            alert(err);
          }
        );
      };

      vm.deviceScan();

      // 장비 생성/수정
      vm.deviceSet = function(mode, deviceId) {
        // mode: create - 생성
        // mode: update - 수정
        
        if (mode === 'create') {
          var deviceSetData = {
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            name: 'SGS_EPTS',
            token: deviceId
          };

          DeviceService.set(deviceSetData).then(function (res) {
            if (res.data.result === 'SUC') {
              DeviceService.myList(vm.deviceMyListData).then(function (res) {
                vm.myDevices = res.data.devices;

                vm.devices = _.reject(vm.devices, {
                  id: deviceId
                });
              }).catch(function(err) {
                console.log(err);
              });
            }
          }).catch(function(err) {
            console.log(err);
          });
        } else if (mode === 'update') {

        }
      };

      // 장비 삭제
      vm.deviceRemove = function(id) {
        $ngConfirm({
          boxWidth: '80%',
          useBootstrap: false,
          title: '해제확인',
          content: '해제하시겠습니까?',
          scope: $scope,
          buttons: {
            confirm: {
              text: '해제',
              btnClass: 'btn-blue',
              action: function (scope, button) {
    
                var deviceRemoveData = {
                  login_id: vm.appContext.user.login_id,
                  uuid: vm.appContext.user.uuid,
                  id: id
                };
    
                DeviceService.remove(deviceRemoveData).then(function (res) {
                  if (res.data.result === 'SUC') {
                    vm.deviceScan();
                  }
                }).catch(function(err) {
                  console.log(err);
                });
    
              }
            },
            cancel: {
              text: '취소',
              btnClass: 'btn-orange',
            },
          }
        });
      };
    }, false);
    // bluetooth end    
  });
  */


  // 결제 기능
  // 결제 정보 등록 API
  // 결제 여부, 결제 내역 불러오는 API

  // paypal direct payment
  // https://developer.paypal.com/docs/classic/paypal-payments-pro/integration-guide/direct-payment/
  // https://demo.paypal.com/us/demo/home 에서 Braintree Direct 선택

  // curl https://api-3t.sandbox.paypal.com/nvp \
  // --insecure  \
  // -d VERSION=56.0 \
  // -d SIGNATURE=api_signature \
  // -d USER=api_username \
  // -d PWD=api_password \
  // -d METHOD=DoDirectPayment \
  // -d PAYMENTACTION=Sale \
  // -d IPADDRESS=192.168.0.1 \
  // -d AMT=8.88 \
  // -d CREDITCARDTYPE=Visa \
  // -d ACCT=4683075410516684 \
  // -d EXPDATE=042011 \
  // -d CVV2=123 \
  // -d FIRSTNAME=John \
  // -d LASTNAME=Smith \
  // -d STREET=1 Main St. \
  // -d CITY=San Jose \
  // -d STATE=CA \
  // -d ZIP=95131 \
  // -d COUNTRYCODE=US

  // 디바이스 관련 시작
  if (vm.appContext.isMobileApp && $stateParams.target === 'MyInfo' && vm.appContext.user.user_type_id == '1') {
    function buf2hex(buffer) { // buffer is an ArrayBuffer
      return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
    }

    // bluetooth start
    if (!vm.appContext.myDevices) {
      vm.appContext.myDevices = [];
      vm.appContext.myDevices2 = [];
    }
    
    vm.deviceMyListData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
    };
    document.addEventListener("deviceready", function() {
      ble.isEnabled(
        function(){
          // Bluetooth is enabled
        },
        function(){
          // Bluetooth not yet enabled so we try to enable it
          ble.enable(
            function(){
              // bluetooth now enabled
            },
            function(err){
              alert('블루투스를 실행해주십시오');
            }
          );
        }
      );

      vm.appContext.deviceScan = function(){

        var devices = [];
        vm.appContext.devices = [];  // 장비 목록

        ble.startScan(
          [],
          function(device){
            if(!device.name || device.name !== 'SGS_EPTS'){
              return;
            }

            console.log('scanned device', device);

            if (!vm.appContext.myDevices) {
              vm.appContext.myDevices = [];
              vm.appContext.myDevices2 = [];
            }

            DeviceService.myList(vm.deviceMyListData).then(function (res) {
              vm.appContext.myDevices = res.data.devices;
              vm.appContext.myDevices = _.uniqBy(vm.appContext.myDevices, 'token');
              
              _.forEach(vm.appContext.myDevices, function(item) {
                item.isConnected = false;

                item.foot = 'R';  // 오른발: R, 왼발: L - 장비에서 직접 데이터를 받을때까지 임시 하드코딩
              });

              vm.appContext.myDevices2 = vm.appContext.myDevices;

              var existingDevice = _.find(vm.appContext.myDevices, {
                token: device.id
              });

              // 등록된 장비 목록을 확인하여 이미 등록된 장비는 연결가능한 디바이스 목록에 표시하지 않음
              if (!existingDevice) {
                devices.push(device);
              }

              // 페이지 접속하면 자동으로 start
              if (vm.appContext.myDevices[0]) {
                vm.deviceStop(vm.appContext.myDevices[0].token);
                vm.deviceStart(vm.appContext.myDevices[0].token);
              }
            }).catch(function(err) {
              console.log(err);
            });
          },
          function(err){
            alert('디바이스 스캔에 실패하였습니다. 다시 시도해주십시오');
          }
        );

        setTimeout(
            ble.stopScan,
            1500,
            function(){
              $scope.$apply(function(){
                vm.appContext.devices = _.uniqBy(devices, 'id');

                // 등록된 디바이스도 없고 스캔된 디바이스도 없으면 다시 스캔
                if (!vm.appContext.myDevices.length && !vm.appContext.devices.length) {
                  console.log('device re scan');
                  vm.appContext.deviceScan();
                }
              });
            },
            function(){
              // Stopping scan failed
            }
        );

      };

      vm.key = 18;

      var serviceId = '0783b03e-8535-b5a0-7140-a304d2495cb7',
        writeCharacteristicId = '0783b03e-8535-b5a0-7140-a304d2495cba',
        readCharacteristicId = '0783b03e-8535-b5a0-7140-a304d2495cb8';

      vm.deviceConnect = function(device_id){
        ble.isConnected(
          device_id,
          function() {
            console.log("Peripheral is connected");
          },
          function() {
            ble.connect(
              device_id,
              function(res){
                console.log('device connect', res);

                var connectedDevice = _.find(vm.appContext.myDevices, {
                  token: device_id
                });
                $scope.$apply(function() {
                  connectedDevice.isConnected = true;
                });
    
                var characteristic = res.characteristics[+vm.key];
                console.log('key', vm.key);
    
                ble.startNotification(res.id, characteristic.service, characteristic.characteristic, function(response) {
                  //console.log('response');
                  //console.log(response);
                  var data = buf2hex(response);
                  
                  // Start Symbol, End Symbol - 7e 로 시작하고 7e 로 끝나는 경우
                  if (data.substr(0, 2) === '7e' && data.substr(-2) === '7e') {
                    //var length = parseInt(data.substr(4, 2) + data.substr(2, 2), 16);
                    var length = data.substr(4, 2) + data.substr(2, 2);
                    //var crc = parseInt(data.substr(-6, 4), 16);
                    var crc = data.substr(-6, 4);
                    var command = data.substr(6, data.length - 12);
                    //var sourceId = parseInt(command.substr(0, 2), 16);
                    var sourceId = command.substr(0, 2);
                    //var destinationId = parseInt(command.substr(2, 2), 16);
                    var destinationId = command.substr(2, 2);
                    var totalPacketNumber = command.substr(4, 4);
                    var currentPacketNumber = command.substr(8, 4);
                    var dataUnit = command.substr(12);
                    //var dataLength = parseInt(dataUnit.substr(2, 2) + dataUnit.substr(0, 2), 16);
                    var dataLength = dataUnit.substr(2, 2) + dataUnit.substr(0, 2);
                    var dataId = dataUnit.substr(4, 2);
                    var dataContents = dataUnit.substr(6);
    
                    // console.log('---------------------------------------------');
                    // console.log('length', length);
                    // console.log('crc', crc);
                    // console.log('command', command);
                    // console.log('sourceId', sourceId);
                    // console.log('destinationId', destinationId);
                    // console.log('totalPacketNumber', totalPacketNumber);
                    // console.log('currentPacketNumber', currentPacketNumber);
                    // console.log('dataUnit', dataUnit);
                    // console.log('dataLength', dataLength);
                    // console.log('dataId', dataId);
                    // console.log('dataContent', dataContents);
                    // console.log('---------------------------------------------');
    
                    if (document.getElementById('rawdata')) { 
                      var html = document.getElementById('rawdata').innerHTML || '';
                      document.getElementById('rawdata').innerHTML = data + '<br>' + html;
                    }
                  }
    
    
    
                }, function(err) {
                  console.log('err', err);
                });
    
                // ble.read(res.id, characteristic.service, characteristic.characteristic, function(response) {
                //   console.log(device_id, serviceId, readCharacteristicId);
    
                //   console.log('read');
                //   console.log(response);
      
                //   ble.disconnect(device_id, function() {
                //     console.log('success1');
                //   }, function(err) {
                //     console.log('fail1', err);
                //   });
                //   console.log('success disconnect');
                // }, function(err) {
                //   console.log(err);
      
                //   ble.disconnect(device_id, function() {
                //     console.log('success2');
                //   }, function(err) {
                //     console.log('fail2', err);
                //   });
                //   console.log('error disconnect');
                // });
              },
              function(err){
                console.log('connect error.', err);
                // 페이지 정보 새로 로드
                $state.go('Service.member', $stateParams, { reload: true });
              }
            );
          }
        );
      };

      // https://www.sitepoint.com/communicating-with-bluetooth-low-energy-devices-in-cordova/
      vm.deviceStart = function(deviceId) {
        console.log('device start', deviceId);
        vm.deviceConnect(deviceId);
      };

      vm.deviceStop = function(deviceId) {
        if (document.getElementById('rawdata')) {
          document.getElementById('rawdata').innerHTML = '';
        }
        
        ble.disconnect(deviceId);
      };

      console.log('device scan');
      vm.appContext.deviceScan();

      // 장비 생성/수정
      vm.appContext.deviceSet = function(mode, deviceId) {
        // mode: create - 생성
        // mode: update - 수정
        
        if (mode === 'create') {
          var deviceSetData = {
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            name: 'SGS_EPTS',
            token: deviceId
          };

          DeviceService.set(deviceSetData).then(function (res) {
            if (res.data.result === 'SUC') {
              DeviceService.myList(vm.deviceMyListData).then(function (res) {
                vm.appContext.myDevices = res.data.devices;

                vm.appContext.devices = _.reject(vm.appContext.devices, {
                  id: deviceId
                });

                // 등록하면 연결 시작
                vm.deviceStart(deviceId);
              }).catch(function(err) {
                console.log(err);
              });
            }
          }).catch(function(err) {
            console.log(err);
          });
        } else if (mode === 'update') {

        }
      };

      // 장비 삭제
      vm.appContext.deviceRemove = function(id, token) {
        $ngConfirm({
          boxWidth: '80%',
          useBootstrap: false,
          title: '해제확인',
          content: '해제하시겠습니까?',
          scope: $scope,
          buttons: {
            confirm: {
              text: '해제',
              btnClass: 'btn-blue',
              action: function (scope, button) {
    
                var deviceRemoveData = {
                  login_id: vm.appContext.user.login_id,
                  uuid: vm.appContext.user.uuid,
                  id: id
                };
    
                DeviceService.remove(deviceRemoveData).then(function (res) {
                  if (res.data.result === 'SUC') {
                    vm.deviceStop(token);

                    $timeout(function() {
                      // 페이지 정보 새로 로드
                      $state.go('Service.member', $stateParams, { reload: true });
                    }, 2000);
                  }
                }).catch(function(err) {
                  console.log(err);
                });
    
              }
            },
            cancel: {
              text: '취소',
              btnClass: 'btn-orange',
            },
          }
        });
      };
    }, false);
    // bluetooth end 

    // 앱을 종료하면 자동으로 stop
    window.onbeforeunload = function() {
      if (vm.appContext.myDevices[0]) {
        vm.deviceStop(vm.appContext.myDevices[0].token);
      }
    };

  }
  // 디바이스 관련 끝
  
  // 감독-선수 소속팀 관련 수정 시작
  vm.beforeCoachPlayerAddTeam = function() {
    // 팀은 최대 10팀까지 추가할 수 있음
    if (vm.members.length > 10) {
      toastr.error('최대 10팀까지 추가하실 수 있습니다.');
    } else {
      vm.showSearchModal = !vm.showSearchModal;
      vm.searchModalMode = 'CoachPlayerSearchTeam';
    }
  };

  // 감독-선수로 로그인한 경우 팀 추가
  vm.coachPlayerAddTeam = function (addTeam) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '추가확인',
      content: '추가하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '추가',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            if (!addTeam) {
              toastr.error('추가할 팀을 선택하십시오');
              return;
            }

            // 추가 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 팀들을 teams_ids 에 추가
              var teams = res.data.teams_ids.split(',');
              teams = _.filter(teams, function(item) {
                return !!item;
              });
              var newTeams = _.concat(teams, addTeam);
              _.forEach(newTeams, function(item, i) {
                newTeams[i] = +item;
              });
              newTeams = _.uniq(newTeams);

              if (typeof addTeam === 'string' || typeof addTeam === 'number') {
                addTeam = [addTeam];
              }

              if (!addTeam || teams.length + addTeam.length > newTeams.length) {
                toastr.error('중복된 팀입니다.');
                return;
              }

              var newTeamsIds = newTeams.join(',');

              vm.joinData.teams_ids = newTeamsIds;






              vm.isEditMode = true;
              vm.saveUser();
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 추가 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 감독-선수로 로그인한 경우 팀 삭제
  vm.coachPlayerRemoveTeam = function (teamId) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            // 삭제 시작
            let team_id = vm.joinData.team_id;

            UserService.info({
              'user_id': vm.appContext.user.user_id
            }).then(function (res) {
              vm.joinData = {
                user_id: vm.appContext.user.user_id,
                login_id: res.data.login_id,
                my_login_id: null,  // 상대팀 선수 등록시에만 입력
                my_uuid: null,      // 상대팀 선수 등록시에만 입력
                name: res.data.name,
                gender: res.data.gender,
                birthdate: {
                  year: res.data.birth_date.substr(0, 4),
                  month: res.data.birth_date.substr(4, 2),
                  date: res.data.birth_date.substr(6, 2)
                },
                birth_date: res.data.birth_date,
                image_url: res.data.image_url,
                code: null,
                verify_code: null,
                country_id: res.data.country_id,
                height: res.data.height,
                weight: res.data.weight,
                blood_type: res.data.blood_type,
                sport_id: res.data.sport_id,
                user_type_id: +res.data.user_type_id,
                user_type_obj: _.find(res.data.user_type_list, {
                  id: +res.data.user_type_id
                }),
                team_id: team_id,
                position_id: res.data.position_id,
                back_number: res.data.back_number,
                movement00_id: res.data.movement00_id,
                movement0_id: res.data.movement0_id,
                movement_id: res.data.movement_id,
                license_list: res.data.license_list,
                license_id: res.data.license_id,
                license_no: res.data.license_no,
                using_foot: res.data.using_foot ? res.data.using_foot : 'R',
                info_agree_flag: res.data.info_agree_flag
              };

              // 선택한 팀을 teams_ids 에서 제외
              var teams = res.data.teams_ids.split(',');
              _.forEach(teams, function(item, i) {
                teams[i] = +item;
              });
              var newTeams = _.difference(teams, [+teamId]),
                newTeamsIds = newTeams.join(',');

              vm.joinData.teams_ids = newTeamsIds ? newTeamsIds : '';

              vm.isEditMode = true;
              vm.saveUser(true, true);
              $timeout(function () {
                vm.isEditMode = false;
              }, 500);
            }).catch(function(err) {
              console.log(err);
            });
            // 삭제 끝

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 팬으로 로그인한 경우 선수 검색, 팀 검색
  vm.modalSelectedTeam = null;    // modal 에서 선택한 팀

  // 선택한 팀 저장
  vm.saveCoachPlayerSelectedTeam = function () {
    vm.coachPlayerAddTeam(vm.modalSelectedTeam);

    vm.modalSelectedTeam = null;
  };

  // 감독-선수로 로그인시 팀선택
  vm.viewCoachPlayerTeamDetail = function(teamId) {
    console.log('team id', teamId);
    $state.go('Service.planner', {type_code:'team',type_name:'팀',team_id:teamId,coach_player_team_id:teamId});
  };
  // 감독-선수 소속팀 관련 수정 끝

}

export default {
  name: 'MemberCtrl',
  fn: MemberCtrl
};